let m_opt = {
  EN : [
    { value: '*', text: 'every min' },
    { value: '*/5', text: '5 min interval'},
    { value: '*/10', text: '10 min interval'},
    { value: '*/15', text: '15 min interval'},
    { value: '*/20', text: '20 min interval'},
    { value: '*/30', text: '30 min interval'},
    { value: '*/45', text: '45 min interval'}
  ],
  KO : [
    { value: '*', text: '매분' },
    { value: '*/5', text: '5 분 마다'},
    { value: '*/10', text: '10 분 마다'},
    { value: '*/15', text: '15 분 마다'},
    { value: '*/20', text: '20 분 마다'},
    { value: '*/30', text: '30 분 마다'},
    { value: '*/45', text: '45 분 마다'}
  ],
  JP : [
    { value: '*', text: '毎分' },
    { value: '*/5', text: '5分間隔'},
    { value: '*/10', text: '10分間隔'},
    { value: '*/15', text: '15分間隔'},
    { value: '*/20', text: '20分間隔'},
    { value: '*/30', text: '30分間隔'},
    { value: '*/45', text: '45分間隔'}
  ]
}

let h_opt = {
  EN : [
    { value: '*', text: 'every hour' },
    { value: '*/2', text: '2 hour interval'},
    { value: '*/3', text: '3 hour interval'},
    { value: '*/4', text: '4 hour interval'}
  ],
  KO : [
    { value: '*', text: '매시간' },
    { value: '*/2', text: '2 시간마다'},
    { value: '*/3', text: '3 시간마다'},
    { value: '*/4', text: '4 시간마다'}
  ],
  JP : [
    { value: '*', text: '毎時' },
    { value: '*/2', text: '2時間間隔'},
    { value: '*/3', text: '3時間間隔'},
    { value: '*/4', text: '4時間間隔'}
  ]
};

const _i18n_data = {
  plz_wait: { EN : "Please wait...", KO : '잠시만 기다려주세요.....', JP : `お待ちください...` },
  wsfinder: { EN : "WebShell", KO : '웹쉘 탐지', JP : `WebShell` },
  webcastle: { EN : "Web Hacking", KO : `웹 방화벽`, JP : `Web Hacking` },
  wfdetect: { EN : "Web Forgery", KO : `웹 위변조`, JP : `Web Forgery` },
  wmds: { EN : "Web Malware\r\nDistribution", KO : `웹 악성코드\n유포지 탐지`, JP : `Web Malware\r\nDistribution` },
  configure: { EN : "Configuration \r\n Status", KO : `설정\n\n상태`, JP : `構成 \r\n ステータス` },
  // using: { EN : "Using", KO : `사용`, },

  contents: { EN : "Contents", KO : `내용`, JP : `Contents` },
  reg_date: { EN : "Registration / Update Date", KO : `등록 정보 및 갱신일`, JP : `登録 / 更新日` },
  service_type: { EN : "Service Type", KO : `구독 정보`, JP : `サービスタイプ` },
  service_type_prev: { EN : "Changed Service Type", KO : `변경된 구독 정보`, JP : `変更されたサービスタイプ` },
  protect_function: { EN : "Protection Function", KO : '보호 범위', JP : `保護機能` },
  included: { EN : "Included", KO : '사용', JP : `付属` },
  choice_date: { EN : "plz, choice date", KO : `날짜를 선택하세요`, JP : `日付を選択してください` },
  generating_report: { EN : "Generating report", KO : "보고서 생성중", JP : `レポートの生成` },
  wmds_patten_update : { EN : "WMDS Pattrn Update", KO : "악성코드 유포 탐지 시스템 패턴 업데이트", JP : `WMDSパターンの更新` },
  wsfinder_pattern_log : { EN : 'WSFinder Pattern Log', KO : "웹쉘 탐지 시스템 패턴 로그", JP : `WSFinderパターンログ` },
  wfdetector_domain_total : { EN : "WFdetector Detection(Domain) Total", KO : "위변조 탐지(도메인) 합계", JP : `WFdetector検出 (サーバー) 合計` },
  wfdetector_server_total : { EN : "WFdetector Detection(Server) Total", KO : "위변조 탐지(도메인) 합계", JP : `WFdetector検出 (サーバー) 合計` },

  // wc
  detectionnly : { EN : "Level", KO : "레벨", JP : `レベル` },
  service : { EN : "Service", KO : "서비스", JP : `サービス` },
  name : { EN : "Name", KO : "이름", JP : `名前` },
  level : { EN : "Level", KO : "레벨", JP : `レベル` },
  domain : { EN : "Domain", KO : "도메인", JP : `ドメイン` },
  mode : { EN : "Mode", KO : "모드", JP : `モード` },
  on : { EN : "On", KO : "사용", JP : `On` },
  off : { EN : "Off", KO : "미사용", JP : `Off` },
  block : { EN : "Block", KO : "차단", JP : `ブロック` },
  detect : { EN : "Detect", KO : "탐지", JP : `検出` },
  schedule : { EN : "Schedule(Daily)", KO : "점검일정(일별)", JP : `スケジュール(毎日)` },
  policy : { EN : "Policy", KO : "정책", JP : `ポリシー` },
  ssdeep : { EN : "SSDEEP", KO : "유사도", JP : `SSDEEP` },
  obfuscation : { EN : "Obfuscation", KO : "난독화", JP : `難読化` },
  realtime : { EN : "Realtime", KO : "실시간", JP : `リアルタイム` },
  backup : { EN : "Backup", KO : "격리", JP : `バックアップ` },
  total : { EN : "Total", KO : "총합", JP : `合計` },
  server_name : { EN : "Server name", KO : "서버 이름",JP : `サーバー名` },
  diagram : { EN : "Selectivity", KO : "분포도", JP : `選択性` },
  risk : { EN : 'Risk', KO : '위험도', JP : `リスク` },
  no : { EN : 'No.', KO : '#', JP : `No.` },
  attacker_ip : { EN : 'Attacker IP', KO : '공격자 IP', JP : `Attacker IP` },
  server : { EN : 'Server', KO : '서버', JP : `サーバー` },
  detail_event : { EN : 'Details Events', KO : '이벤트 상세', JP : `イベント詳細` },
  message : { EN : 'Message', KO : '정보', JP : `メッセージ` },
  target : { EN : 'Target', KO : '대상', JP : `ターゲット` },

  // wsfinder
  detected_value : { EN : "Detected Value", KO : "탐지된 값",JP : `検出値` },
  username : { EN : 'Username', KO : '사용자명', JP : `ユーザー名` },
  ev : { EN : 'Report period', KO : '보고서 기간',JP : `レポート期間`  },
  event : { EN : 'Event', KO : '이벤트', JP : `イベント` },
  isolation : { EN : 'Isolation', KO : '격리', JP : `隔離` },
  report_period : { EN : 'Report period', KO : '보고서 기간', JP : `レポート期間` },
  contract : { EN : 'Contract', KO : '사용량', JP : `契約` },
  status : { EN : 'Status', KO : '상태',JP : `ステータス` },
  count : { EN : 'Count', KO : '합계', JP : `カウント` },
  pattern : { EN : 'Pattern', KO : '패턴', JP : `パターン` },
  category : { EN : 'Category', KO : '구분', JP : `カテゴリー` },
  path : { EN : 'Path', KO : '경로', JP : `パス` },
  detect_time : { EN : 'Detected\r\nTimestamp', KO : '탐지 시각', JP : `検出された\r\nタイムスタンプ` },
  updated : { EN : 'Updated', KO : '업데이트', JP : `更新しました` },
  date : { EN : 'Date', KO : '일자', JP : `日付` },
  type : { EN : 'Type', KO : '정책', JP : `タイプ` },
  code : { EN : 'Code', KO : '코드', JP : `コード` },
  deleted : { EN : 'Deleted', KO : '삭제일자', JP : `検出` },

  // WMDS
  fqdn : { EN : 'FQDN', KO : 'FQDN', JP : `FQDN` },
  domain_fqdn : { EN : 'Domain name(FQDN)', KO : '도메인 이름(FQDN)', JP : `ドメイン名(FQDN)` },
  this_month : { EN : 'This Month', KO : '이번 달', JP : `今月` },

  // wf
  folder : { EN : 'folder', KO : '폴더', JP : `folder` },
  file : { EN : 'file', KO : '파일', JP : `file` },
  host : { EN : 'host', KO : '호스트', JP : `ホスト` },
  ip : { EN : 'IP', KO : 'IP 주소', JP : `IP` },
  daily_domain_detect : { EN : 'Daily detection of domain', KO : '일별 도메인 탐지', JP : `毎日のドメイン検出` },
  changed : { EN : 'Changed', KO : '변화됨', JP : `変更しました` },
  action : { EN : 'Action', KO : '조치', JP : `アクション` },
  domain_and_server : { EN : 'Domain Name / Web Server', KO : '도메인명 / 웹서버', JP : `ドメイン名 / Webサーバー` },

  min : { EN : 'min', KO : '분', JP : `分` },
  hour : { EN : 'hour', KO : '시', JP : `時間` },
  // risk : { EN : 'Risk', KO : '위험도' },
  // etc
  generated_report : { EN : 'Generated Report', KO : '보고서 생성 완료!', JP : `生成されたレポート` },
  generated_report_failed : { EN : 'Generate reporting failed', KO : '보고서 생성 실패!',JP : `レポートの生成に失敗しました` },
  export_done : { EN : 'export done!', KO : '보고서가 곧 다운로드됩니다!!',JP : `輸出完了！` },

  // wmds
  scan : { EN : 'scan count', KO : '점검 수', JP : `スキャン数` },
  page : { EN : 'scan page', KO : '점검 페이지',JP : `ページをスキャンする` },
  max_page : { EN : "Max Page", KO : "최대 점검 페이지",JP : `最大ページ数` },
  detail : { EN : 'Detail', KO : '상세', JP : `Detail` },
  // status : { EN : 'Status', KO : '상태' },
};

// report format
import Contents from './Report.i18n/0.index.i18n' // 코드 개선 해야 함
import Caution from './Report.i18n/1.caution.i18n'
import ReportWebCastle from './Report.i18n/2.webcastle.i18n'
import ReportWSFinder from './Report.i18n/3.wsfinder.i18n'
import ReportWMDS from './Report.i18n/4.wmds.i18n'
import ReportWFDetect from './Report.i18n/5.wfdetect.i18n'

// chart
// import LineChart from './LineExample'
import lineChart from './chart/MainChart';
import BarChart from './chart/BarChart';
import DoughnutChart from './chart/DoughnutChart';
import StackedVerticalBarChart from './chart/StackedVerticalBarChart'

import { api } from '@/f1/service';
import moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
const default_moment = extendMoment(require('moment'));

import Custom from '@/f1/service/custom';
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import { hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities';
import jsPDF from 'jspdf'
// import ColorViewVue from '../../../views/theme/ColorView.vue'
import 'jspdf-autotable' // table component for jsPDF
import logoImageUrl from '../../../assets/logo.png'
import logoFooterUrl from '../../../assets/footer_onpremise.png'

// 위에 사용 안하는 것 확인 필요
import vSelect from 'vue-select';
import VueHotelDatepicker from '@northwalker/vue-hotel-datepicker'
import _ from 'lodash'
// 나중에 아래 폰트 최적화 필요
import SetMalgun from './fonts/malgun'
import SetMalgunbd from './fonts/malgun-bold'
// import SetNotoSansCJKjp from './fonts/NotoSansCJKjp'
// import SetNotoSansCJKjpbd from './fonts/NotoSansCJKjp-bold'

// import Language from './language';
import StepProgress from 'vue-step-progress';
import f1pdf from './f1pdf'

// 도메인별 보고서 준비
import Multiselect from 'vue-multiselect'
import ruleI18n from '../WebCastle/log/rule.i18n' // 정책 번영 파일 추가
import { number } from '../../filter'

export default {
  components: {
    Multiselect,
    StepProgress,

    // report
    Contents,
    Caution,
    ReportWebCastle,
    ReportWSFinder,
    ReportWMDS,
    ReportWFDetect,

    // util
    hexToRgba,
    VueHotelDatepicker,
    vSelect,

    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      ruleI18n,
      index_title : 0,
      index_title_list : [],
      SUMMARY : { group : '', service_name : '', prev_subscription : [] },
      domain_loading : false,
      webcastle : {
        use : 0,
        summary_1_4 : [],
        agent_list : [],
        agent_daily_stats : [],
        domain_severity_stats : [],
      },
      agent_list : [],
      agent : [],
      domain_list : [],
      domain : [],

      custom : Custom.custom_default,
      is_wmds : true,
      is_wsf : true,
      is_wc : true,
      is_wf : true,

      start_wc : 1,
      start_wsf : 1,
      start_wmds : 1,
      start_wf : 1,

      loading : false,
      codes,
      auth,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
      is_report_custom : false, // 보고서 기간 선택
      blank_chart_data : [],
      opt : {
        month : '',
        year : ''
      },
      start_year : '2019', // uwss 시작년
      max : 90,
      start : 1,

      // 아래는 확인 필요
      // webcastle
      castle_agent  : [],
      WebCastle_attack_trend_total_2_3 : {},
      WebCastle_total_info_by_server_2_2_3_1 : [],
      WebCastle_total_info_by_server_2_2_3_2 : [],
      WebCastle_total_info_by_domain_2_2_4_1 : [],
      WebCastle_Daily_log_by_server : [],
      WebCastle_Daily_log_by_domain : [],

      WebCastle_Daily_Detecting : [],
      WebCastle_Daily_Blocking : [],

      castle_summary : {
        rs_event_by_domain : [],
        web_security_configuration_status : [],
        wc_status : 0,     // webacstle status
        event_total : {    // Total number of security events
            block: 0,
            detect : 0
        },
        ws_status : [], // web server & webcastle status
        top10 : [], // Detection and blocking events per domain
      },
      castle_recent : {},
      // wsfinder 데이터
      WSFinder_Daily_Detection_Total : [],
      WSFinder_Daily_Detection_Server : [],
      WSFinder_Daily_Pattern : [],
      wsfinder_summary : {
        web_server_and_wf_detector_status : [],
        agent_info : [],
        domain_per_number : [],
        wf_total_detection : [],
        wf_events_domain : [],
        wf_total_number_per_server : [],
        web_security_configuration_status : [],
        total_event : [],
        pattern_update : [],
        server_event : [],
        security_event : {
          detect : 0,
          backup : 0,
          scan : 0,
        }
      },
      wsfinder_recent : {
        wf_daily_detection_total : [],
        wsf_daily_detection_server : [],
        pattern : []
      },
      wsfinder : {
        summary_1_4 : [],
        top_n_detect_agent : [],
        pattern : { total : 0, updated : 0 },
        agent_list : [],
        agent_daily_stats : [],
        agent_check_table : [],
        pattern_list : [],
        // forgery
        wf_agent_list : [],

        wf_events_server : [], // 작업 필요
        wf_total_detection : [], // 작업 필요
      },

      // WMDS 데이터
      wmds : {
        site_list_alive : [],
        site_list : [],
        summary_1_4 : [],
        domain_check_table : [],
        top_n_detect_domain : [],
        pattern : {
          total : 0,
          updated : 0,
          pattern_list : []
        }
      },
      wmds_summary : {

        events_domain : [],
        domain_and_wf_detector_status : [],
        updated_pattern_description : [],
        events_total : [],
        domain_and_wmds_status : [],
        total_number_per_domain : [],
        wf_total_detection : [],
        wf_events_domain : [],
        web_security_configuration_status : [],
        general_information : {},
        wf_total_number_per_domain : []
      },
      wmds_recent : {
        domain_check_table : [],
        wf_daily_detection_total : [],
        wf_daily_detection_domain : []
      },
      WMDS_Daily_Detecting_Total : [],
      WMDS_Daily_Detecting_Domain : [],
      WMDS_Daily_Detecting : [],
      WMDS_Daily_Pattern : [],

      // WF 데이터
      WF_Daily_Detect_Total : [],
      WF_Daily_detect_domain : [],
      WF_Daily_detect_server :[],
      from : '2020-01-01',
      to : '2020-02-01',
      formData: [],
      minDate: "2000-01-01",
      maxDate: moment(new Date()).format('YYYY-MM-DD'),
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
    i18n_data() { return _i18n_data; },
    years() {
      let year_list = []
      for (let y = this.start_year; y <= new Date().getFullYear(); y++) { year_list.push(y) }
      return year_list.reverse()
    },
    dynamic_row_span() {
      let count = 8
      count += this.wsfinder  && this.wsfinder.summary_1_4 ? this.wsfinder.summary_1_4.length : 0
      // console.log("wsfinder", this.wsfinder_summary.web_security_configuration_status.length)
      count += this.wmds  && this.wmds.summary_1_4 ? this.wmds.summary_1_4.length : 0
      // console.log("wmds", this.wmds.summary_1_4.length)
      count += this.webcastle  && this.webcastle.summary_1_4 ? this.webcastle.summary_1_4.length : 0
      // console.log("castle", this.castle_summary.web_security_configuration_status.length)
      return this.loading ? 7 : count
    },
    status_rowspan() {
      try {
        // console.log(_.filter([this.is_wc, this.is_wmds, this.is_wsf, this.is_wmds || this.is_wsf], x => x == true).length)
        return _.filter([this.is_wc, this.is_wmds, this.is_wsf, this.is_wmds || this.is_wsf], x => x == true).length
      } catch (error) {
        console.log(error)
      }

      // let cnt = 0
      // cnt += this.is_wc ? 1 : 0
      // cnt += this.is_wsf ? 1 : 0
      // cnt += this.is_wmds ? 1 : 0
      // cnt += this.is_wsf || this.wmds ? 1 : 0
      // console.log('cnt', cnt)
      // return cnt
    },
  },
  methods: {
    // 도메인별 보고서를 위한 옵션
    show_wc_domain() {
      return (this.domain.length > 0 && this.agent.length > 0) || (this.agent.length > 0) || (this.agent.length + this.domain.length < 1)
      // console.log('this.domain', this.domain)
      // return domain ? _.filter(this.domain, x => x == domain).length > 0 :
    },
    show_wc_agent() {
      return (this.domain.length < 1 && this.agent.length > 0) || (this.domain.length < 1) || (this.agent.length + this.domain.length < 1)
      // return nickname ? _.filter(this.agent, x => x == nickname).length > 0 : this.agent.length > 0
    },
    //
    get_index_title() {
      this.index_title +=1
      // console.log('generate', this.index_title_list.length, this.index_title, this.index_title_list[this.index_title -1])
      if(this.index_title > this.index_title_list.length) {
        // 목차 벗어남, 예외 처리
        console.log('목차 벗어남, 예외 처리')
        this.index_title = this.index_title_list.length
      }
      return this.index_title_list[this.index_title -1]
    },
    is_f1security_slogan() {
      return this.custom && this.custom.slogan && this.custom.slogan.toLowerCase().indexOf('f1-uwss') > -1
    },
    domain_reload(domain="") {
      console.log('reload', domain, 'start new domain report')
      this.report()
    },
    is_custom() { return this.custom.slogan.indexOf('F1-UWSS') > -1 || !this.custom.slogan ? true : false },
    add_tag (newTag) { this.agent_list.push(newTag) && this.agent.push(newTag.agent_id) },
    getAgentList: function() {
      api.webcastle.WebCastle({ target : 'agent', cmd : 'list.info' }).then(rs => {
        this.agent_list = []
        rs.body ? rs.body.forEach(agent => this.agent_list.push(agent)) : ''
        // console.log('load agents', this.agent_list.length)

      }).catch(error => {
        console.error(error)
      })
    },
    getDomainList: function() {
      this.domain_loading = true
      console.log('search', this.agent.length, _.map(this.agent, x => x.agent_id))
      api.webcastle.WebCastle({ target : 'agent', cmd : 'list.domain', body : { from : this.from, to : this.to, agent_list : _.map(this.agent, x => x.agent_id) } }).then(rs => {
        this.domain_list = []
        rs.body ? rs.body.forEach(domain => this.domain_list.push(domain)) : ''
        console.log('loaded domain', rs.body.length)
        this.domain_loading = false
      }).catch(error => {
        this.domain_loading = false
        console.log(error)
      })
    },
    numbering() {
      console.log('this.is_wmds', this.start_wmds)

      this.start_wc = (this.start || 1) + 1
      console.log('this.start_wc', this.start_wc)
      this.start_wsf = this.is_wc ? this.start_wc + 1 : this.start_wc
      console.log('this.start_wsf', this.start_wsf)
      this.start_wmds = this.is_wsf ? this.start_wsf + 1 : this.start_wsf
      console.log('this.start_wmds', this.start_wmds)
      this.start_wf = this.is_wmds ? this.start_wmds + 1 : this.start_wmds
      console.log('this.start_wmds', this.start_wf)
    },
    // custom
    webcastle_msg(x) {
      if(!x) { return '-' }

      try { return JSON.parse(x).messages ? this.ruleI18n[JSON.parse(x).messages[0].details.ruleId][this.i18n] : JSON.parse(x).message }
      catch (error) {
        // 2022.07 신규 i18n
        try { return x[this.i18n] } catch (e) {
          try { return JSON.parse(x).messages[0].message } catch (ee) { console.log(ee) }
        }
      }
    },
    // webcastle_msg(x) {
    //   if(!x) { return '-' }
    //   try { return typeof x == typeof '' ? JSON.parse(x).messages[0].message : x.messages[0].message }
    //   catch (error) { return x.message }
    // },
    cron_filter: function (v) {
      if (!v) return '';
      let vs = v.trim().split(' ');
      let m = _.find(m_opt[this.i18n || 'EN'], { value: vs[0] });
      let h = _.find(h_opt[this.i18n || 'EN'], { value: vs[1] });

      return (h && h.text || vs[1]) + ' ' + (m && m.text || vs[0])
    },
    cron_parse(cron, is_add = true) {
      let origin = cron.split(' ');
      // console.log('origin', origin, origin[1] != '*' ? origin[1].replace(/[\\*]/gm, '') : 0)
      let min_has_interval = origin[0].indexOf('/') > -1;
      let hour_has_interval = origin[1].indexOf('/') > -1;
      if (hour_has_interval) {

        // 매시간별 반복은 시간 차이 기준으로 컨버팅 불필요
      } else {
        if (origin[1] != '*') {
          origin[1] = (Number(origin[1] != '*' ? origin[1].replace(/[/|\\*]/gm, '') : 0) + 24 + (is_add ? +(new Date().getTimezoneOffset() / 60) : -(new Date().getTimezoneOffset() / 60))) % 24;
        }
      }

      if (min_has_interval) { '*/' + origin[0]; }
      if (hour_has_interval) { '*/' + origin[1]; }
      return this.cron_filter(origin.join(' '));
    },
    wmds_schedule: function(schedule) { return _.map(schedule, s => this.cron_parse(s, false)) },
    get_doughnut_data: function(severity) {
      let doughnut_data = { labels: [], datasets: [ { label: 'Risk analysis', backgroundColor: [], data: [] } ] }
      _.sortBy(severity, s => (s.detect + s.block)).forEach(x => {
        doughnut_data.labels.push(codes.WAF_SEVERITY_TO_DESC_EASY(x.Key, this.i18n))
        doughnut_data.datasets[0].data.push(x.Value)
        doughnut_data.datasets[0].backgroundColor.push(codes.WAF_SEVERITY_TO_COLOR_EASY(x.Key))
      })
      return doughnut_data
    },
    // Regex	Hash	URL	SSDEEP	Obfuscation
    wsfinder_rule(setting) { return _.map(((typeof '' == typeof setting ? JSON.parse(setting) : setting).rule || []), r => r.toLowerCase()) },
    // 아래 수정 해야 함
    async report(custom_start = '', custom_end = '') {
      // console.log(this.is_wf,  this.is_wsf == false, this.is_wmds == false)

      // if(this.is_wf && this.is_wsf == false && this.is_wmds == false) {
      //   return this.$toastr.e("required checking WSFinder or WMDS")
      // }
      // 끌올
      try {
        this.numbering()
        let frame = document.getElementById('app')
        if(frame) {
          frame.scrollTop = 0
        }
      } catch (e) { console.log("up to top failed", e) }

      this.loading = true
      if(custom_start) { this.from = moment(custom_start).format('YYYY-MM-DD') }
      if(custom_end) { this.to = moment(custom_end).format('YYYY-MM-DD') }

      let start
      let end
      let range = []

      if(this.is_report_custom) {
        start = custom_start ? moment(custom_start).format('YYYY-MM-DD') : default_moment(this.from, 'YYYY-MM-DD').format('YYYY-MM-DD')
        end = custom_end ? moment(custom_end).format('YYYY-MM-DD') : default_moment(this.to, 'YYYY-MM-DD').format('YYYY-MM-DD')
        console.log('is custom', 'start', start, 'end', end, range.length)
      } else {
        if(!this.opt.month || !this.opt.year) {
          this.loading = false
          return this.$toastr.w(this.i18n_data['choice_date'][this.i18n])
        }

        this.opt.year = this.opt.year ? this.opt.year : new Date().getFullYear()

        let month = this.opt.month && this.opt.month.value ? this.opt.month.value : new Date().getMonth()
        month = month.toString().padStart(2, '0')
        let day = new Date(this.opt.year, month, 0).getDate().toString()
        day = day.padStart(2, '0')
        start = `${this.opt.year}-${month}-01`
        end = `${this.opt.year}-${month}-${day}`
        console.log('is monthly', 'start', start, 'end', end)
      }

      this.from = start
      this.to = end
      this.index_title = 0
      let CHART_ZERO_FILL = []

      try {
        // TODO : 나중에 백엔드에서는 일자별 처리 안해줘도 되도록 클라이언트에서 처리 예정
        range = default_moment.range(start, end);
        const days = range.by('days');
        const search_range = [...days].map(date => date.format('YYYY-MM-DD'))
        CHART_ZERO_FILL = search_range.map(x => 0)

        console.log("search", search_range.length, search_range.length)

        if(search_range.length > this.max) { return this.$toastr.w(`Please choose within ${this.max} days.`) }


        this.$toastr.i(this.i18n_data['generating_report'][this.i18n || 'EN'])

        var search = {
          target : 'report', cmd : 'report.new.web', limit : this.so.perPage,
          offset : (this.so.currentPage - 1) * this.so.perPage,
          body: { and: [], or: [], sort: [], from : this.from, to : this.to, is_custom : this.is_report_custom }
        }
        console.log("search", search.body.from, '~', search.body.to)

        // 웹캐슬 도메인별일 경우 cmd 변경하여 요청
        if(this.is_wc  && !this.is_wmds && !this.is_wf && !this.is_wsf) {
          console.log('agent', this.agent, 'domain', this.domain)

          if(this.agent.length > 0 && this.domain.length > 0) {
            search.cmd = 'report.new.web.domain'
            search.body.domain_list = this.domain
            search.body.agent_list = _.map(this.agent, x => x.agent_id)
            console.log('agent', this.agent.length, 'domain', this.domain.length)
          } else if(this.agent.length > 0){
            search.cmd = 'report.new.web.domain'
            search.body.agent_list = _.map(this.agent, x => x.agent_id)
            console.log('agent', this.agent.length)
          } else {
            console.log('all-in-one report, no have agent and domain data')
          }
        } else {
          console.log('all-in-one report')
        }

        // 구독 정보 등 보이기
        try {
          let rs = await api.member.Manager_Call('group', 'summary.report', search.body);
          if(rs.error) { this.$toastr.e("summary load failed") }
          else {
            // console.log('SUMMARY', rs.body)
            this.SUMMARY = rs.body
          }

        } catch(e) {
          console.log(e)
        }

        if(this.is_wmds || this.is_wf) {
          // wmds 시작
          let WMDS = await api.wmds.WMDS(search)

          this.wmds = Object.assign({ summary_1_4 : [], site_list : [] }, this.castle_summary, WMDS.body);

          // 전체 카운트 정보
          this.wmds.total_scan = _.sumBy(this.wmds.total_daily_stats, x => x.total_scan)
          this.wmds.total_page = _.sumBy(this.wmds.total_daily_stats, x => x.total_page)
          this.wmds.total_detect = _.sumBy(this.wmds.total_daily_stats, x => x.total_detect)

          this.wmds.site_list_alive = _.filter(this.wmds.site_list, x => x.is_del == false)
          this.wmds = Object.assign({}, this.wmds, { summary_1_4 : this.wmds.site_list })

          // this.wmds_summary = Object.assign({}, this.wmds_summary, WMDS.body);
          // this.wmds_recent = Object.assign({}, this.wmds_summary, WMDS.body);
          //4.1.4 Domain & WMDS Status

          //4.2.1.1. Daily detection (Total)
          let WMDS_Daily_Detecting_Total = {
            labels: [],
            datasets: [
              { yAxisID : "y-axis-detect", label: `WMDS ${this.i18n_data['detect'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(0), 70), },
              { yAxisID : "y-axis-base", label: `WMDS ${this.i18n_data['scan'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(3), 70), },
              { yAxisID : "y-axis-base", label: `WMDS ${this.i18n_data['page'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(4), 70), }
            ]
          }
          // _.map(this.wmds_recent.detect_count, r => {
          //   WMDS_Daily_Detecting_Total.labels.push(r.day)
          //   WMDS_Daily_Detecting_Total.datasets[0].data.push(r.cnt)
          // })
          _.forEach(this.wmds.total_daily_stats, r => {
            WMDS_Daily_Detecting_Total.labels.push(r.date)
            WMDS_Daily_Detecting_Total.datasets[0].data.push(r.total_detect)
            WMDS_Daily_Detecting_Total.datasets[1].data.push(r.total_scan)
            WMDS_Daily_Detecting_Total.datasets[2].data.push(r.total_page)
          })
          this.WMDS_Daily_Detecting = WMDS_Daily_Detecting_Total;
          this.WMDS_Daily_Detecting.options = {
            scales: {
              yAxes : [
                { labels : { show : true }, position : "right", id : "y-axis-detect", ticks: { stepSize : 1, } },
                { position : "left", id : "y-axis-base", }
              ]
            }
          }

          //4.2.2.1. Daily detection (domain 1)

          this.wmds.domain_check_table = _.map(this.wmds.domain_daily_stats, r => {

            r.chart = {
              labels : [],
              datasets: [
                { yAxisID : "y-axis-detect", label: `WMDS ${this.i18n_data['detect'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(0), 70), },
                { yAxisID : "y-axis-base", label: `WMDS ${this.i18n_data['scan'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(3), 70), },
                { yAxisID : "y-axis-base", label: `WMDS ${this.i18n_data['page'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(4), 70), }
              ],
              options: {
                scales: {
                  yAxes : [
                    { labels : { show : true }, position : "right", id : "y-axis-detect", ticks: { stepSize : 1, } },
                    { position : "left", id : "y-axis-base", }
                  ]
                }
              }
            }

            _.map(r.data, t => { r.chart.labels.push(t.date) })

            let date_list = _.map(r.data, d => d.date)
            // console.log('date_list', date_list)

            _.forEach(search_range, day => {
              r.chart.labels.push(day)
              let index = _.findIndex(date_list, dd => dd == day)

              if(index < 0) {
                r.chart.datasets[0].data.push(0)
                r.chart.datasets[1].data.push(0)
                r.chart.datasets[2].data.push(0)
                return
              }

              r.chart.datasets[0].data.push(r.data[index].total_detect)
              r.chart.datasets[1].data.push(r.data[index].total_scan)
              r.chart.datasets[2].data.push(r.data[index].total_page)

              // r.chart.datasets[0].data.push(t.cnt)


            })

            return r
          })

          //4.4.1.2. WMDS_Daily_Pattern_Update
          //5.4.1.2. Daily Update
          let WMDS_Daily_Pattern_Update = {
            labels: [],
            datasets: [ { label: this.i18n_data['wmds_patten_update'][this.i18n], data: [], backgroundColor: hexToRgba('#08A0E6', 70), } ]
          }

          _.map(this.wmds_recent.pattern_update, r => {
            WMDS_Daily_Pattern_Update.labels.push(r.day)
            WMDS_Daily_Pattern_Update.datasets[0].data.push(r.cnt)
          })
          this.WMDS_Daily_Pattern = WMDS_Daily_Pattern_Update;
        }

        if(this.is_wc) {
          // webcastle 시작
          try {
            let WC = await api.webcastle.WebCastle(search)

            this.webcastle = Object.assign({ summary_1_4 : [], agent_list : [], agent_daily_stats : [], domain_daily_stats : [], severity_daily_stats : [] }, this.castle_summary, WC.body);

            // 전체 카운트 정보
            let total = _.sumBy(Array.from(this.webcastle.agent_daily_stats), x => _.sumBy(x.data, y => y.block + y.detect))
            this.webcastle.total_block = _.sumBy(Array.from(this.webcastle.agent_daily_stats), x => _.sumBy(x.data, y => y.block))
            this.webcastle.total_detect = total - this.webcastle.total_block
            this.webcastle.agent_list_alive = _.filter(this.webcastle.agent_list, x => x.is_del == false)
            this.webcastle.summary_1_4 = []
            _.forEach(this.webcastle.agent_list_alive, x => x.policy.forEach(p => this.webcastle.summary_1_4.push(Object.assign({}, x, p))))

            // this.webcastle.top_n_attack_domain.concat(empty_top_domain_list)

            //2.2.1.1. Daily_Detecting_Total
            let Daily_Detecting_Total = {
              labels: [],
              datasets: [ { label: `WEBCastle ${this.i18n_data['detect'][this.i18n]}`, data: [], backgroundColor: hexToRgba('#FF0000', 70), } ]
            }

            // //2.2.1.2. Daliy_Blocking_Total
            let Daliy_Blocking_Total = {
              labels: [],
              datasets: [ { label: `WEBCastle ${this.i18n_data['block'][this.i18n]}`, data: [], backgroundColor: hexToRgba('#FFFF00', 70), } ]
            }

            // // 2.2.3
            this.WebCastle_Daily_log_by_server = []
            this.WebCastle_Daily_log_by_domain = []

            // daily_log_format
            let daily_log_format = {
                deleted_at : '',
                name : '',
                labels: search_range,
                datasets: [
                  { label: this.i18n_data['detect'][this.i18n], data: [], backgroundColor: hexToRgba('#FF0000', 70) } ,
                  { label: this.i18n_data['block'][this.i18n], data: [], backgroundColor: hexToRgba('#FFF000', 70) }
                ]
              }

              this.WebCastle_total_info_by_domain_2_2_4_1 = []

            // // 2.3 attack trend
            let Daily_severity_2_3 = { datasets: [], labels: [], }
            Daily_severity_2_3.datasets = _.map(codes.WAF_SEVERITYS_EASY, x => {
              return { label: codes.WAF_SEVERITY_TO_DESC_EASY(x, this.i18n), data: [], backgroundColor: hexToRgba(codes.WAF_SEVERITY_TO_COLOR_EASY(x, 'hex'), 70) }
            })

            search_range.forEach(x => {
              // detect
              Daily_Detecting_Total.labels.push(x)
              Daily_Detecting_Total.datasets[0].data.push(0)
              // block
              Daliy_Blocking_Total.labels.push(x)
              Daliy_Blocking_Total.datasets[0].data.push(0)

              // server
              // daily_log_format.labels.push(x)
              daily_log_format.datasets[0].data.push(0)
              daily_log_format.datasets[1].data.push(0)

              // attack trend
              // 일할 데이터 넣기
              Daily_severity_2_3.labels.push(x)
              Daily_severity_2_3.datasets.forEach(i => i.data.push(0))

            })

            // 데이터 없는 애들은 직접 데이터 생성 해줘야 함
            Array.from(this.webcastle.agent_daily_stats).forEach(agent => {

              let server = JSON.parse(JSON.stringify(daily_log_format))
              server.name = agent.name
              server.deleted_at = agent.deleted_at

              agent.data.forEach(daily_info => {
                let index_total_d = _.findIndex(Daily_Detecting_Total.labels, x => x == daily_info.date)
                Daily_Detecting_Total.datasets[0].data[index_total_d] = daily_info.detect

                let index_total_b = _.findIndex(Daliy_Blocking_Total.labels, x => x == daily_info.date)
                Daliy_Blocking_Total.datasets[0].data[index_total_b] = daily_info.block

                let index_server = _.findIndex(server.labels, x => x == daily_info.date)
                server.datasets[0].data[index_server] = daily_info.detect
                server.datasets[1].data[index_server] = daily_info.block

              })

              this.WebCastle_Daily_log_by_server.push(server)
            })
            this.WebCastle_Daily_Detecting = Daily_Detecting_Total;
            this.WebCastle_Daily_Blocking = Daliy_Blocking_Total;


            // 도메인 처리 부분
            Array.from(this.webcastle.domain_daily_stats).forEach(d => {
              let domain = JSON.parse(JSON.stringify(daily_log_format))
              domain.name = d.name
              domain.deleted_at = d.deleted_at

              d.data.forEach(daily_info => {
                let index_domain = _.findIndex(domain.labels, x => x == daily_info.date)
                domain.datasets[0].data[index_domain] = daily_info.detect
                domain.datasets[1].data[index_domain] = daily_info.block
              })

              this.WebCastle_Daily_log_by_domain.push(domain)
            })


            this.WebCastle_total_info_by_server_2_2_3_1 = this.webcastle.agent_severity_stats
            this.WebCastle_total_info_by_server_2_2_3_2 = this.webcastle.domain_severity_stats

            this.webcastle.top_n_attack_from = this.webcastle.top_n_attack_from
            this.webcastle.rs_event_by_domain = this.webcastle.top_n_attack_from

            Array.from(this.webcastle.severity_daily_stats).forEach(severity => {
                // attack trend
                severity.data.forEach(daily_info => {

                  let index = _.findIndex(Daily_severity_2_3.datasets, ss => ss.label == codes.WAF_SEVERITY_TO_DESC_EASY(severity.name, this.i18n))
                  let dindex = Daily_severity_2_3.labels.indexOf(daily_info.date)

                  Daily_severity_2_3.datasets[index].data[dindex] = daily_info.detect + daily_info.block

                })
              })

            // console.log(this.webcastle, "webcastle")

            this.WebCastle_attack_trend_total_2_3 = Daily_severity_2_3
          } catch (e) {
            console.log(e)
            this.$toastr.e()
          }
        } else {
          this.webcastle = Object.assign({ use : 0, summary_1_4 : [], agent_list : [], agent_daily_stats : [], domain_severity_stats : [] })
        }


        // wfdetect or wsfinder
        if(this.is_wsf || this.is_wf) {
          try {
            // WSFinder  부분
            //3.2.1.1. Daliy_Detection_Total
            let WSF = await api.wsfinder.WSFinder(search)
            this.wsfinder = Object.assign({ summary_1_4 : [], site_list : [], agent_check_table : [] }, this.wsfinder_summary, WSF.body);
            console.log('this.wsfinder', this.wsfinder.total_daily_stats)

            // 전체 카운트 정보
            this.wsfinder.total_scan = _.sumBy(this.wsfinder.total_daily_stats, x => x.total_scan)
            this.wsfinder.total_file = _.sumBy(this.wsfinder.total_daily_stats, x => x.total_file_scan)
            this.wsfinder.total_detect = _.sumBy(this.wsfinder.total_daily_stats, x => x.total_detect)
            this.wsfinder.total_backup = _.sumBy(this.wsfinder.total_daily_stats, x => x.total_backup)
            this.wsfinder.total_forgery = _.sumBy(this.wsfinder.total_daily_stats_forgery, x => x.total_forgery)

            // console.log('this.wsfinder.total_forgery', this.wsfinder.total_daily_stats)

            this.wsfinder.agent_list_alive = _.filter(this.wsfinder.agent_list, x => x.is_del == false)
            this.wsfinder.wf_agent_list = _.filter(this.wsfinder.agent_list, x => x.forgery && x.forgery.is_alive == false)

            this.wsfinder = Object.assign({}, this.wsfinder, { summary_1_4 : this.wsfinder.agent_list })

            // console.log('WSF', WSF)
            let max = _.maxBy(this.wsfinder.total_daily_stats, x => x.total_detect)
            let WSF_Detect_Total = {
              labels: [],
              datasets: [
                { yAxisID : "y-axis-detect", label: `WSFinder ${this.i18n_data['detect'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(0), 70), },
                { yAxisID : "y-axis-base", label: `WSFinder ${this.i18n_data['isolation'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(3), 70), },
                // { yAxisID : "y-axis-base", label: `WSFinder ${this.i18n_data['scan'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(4), 70), }
                // { label: `WSFinder ${this.i18n_data['detect'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WSF_LEVEL_TO_COLOR(5), 70), },
                // { label: `WSFinder ${this.i18n_data['isolation'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WSF_LEVEL_TO_COLOR(3), 70), }
              ],
              options: {
                scales: {
                  yAxes : [
                    { labels : { show : true }, position : "right", id : "y-axis-detect", ticks: { stepSize : Math.ceil(max ? max.total_detect / 10 : 0), beginAtZero : true } },
                    { position : "left", id : "y-axis-base", ticks: { stepSize : 1, beginAtZero : true } }
                  ]
                }
              }
            }

            // let WSF_Detect_Total = {
            //   labels: [],
            //   datasets: [
            //     { label: `WSFinder ${this.i18n_data['detect'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WSF_LEVEL_TO_COLOR(5), 70), },
            //     { label: `WSFinder ${this.i18n_data['isolation'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WSF_LEVEL_TO_COLOR(3), 70), }
            //   ]
            // }

            WSF_Detect_Total.labels = search_range
            for (let o = 0; o < this.wsfinder.total_daily_stats.length; o++) {
              let total_index = _.findIndex(WSF_Detect_Total.labels, this.wsfinder.total_daily_stats[o].day)
              if(total_index < -1) {
                WSF_Detect_Total.datasets[0].data.push(0)
                WSF_Detect_Total.datasets[1].data.push(0)
                continue
              }

              WSF_Detect_Total.datasets[0].data.push(this.wsfinder.total_daily_stats[o].total_detect)
              WSF_Detect_Total.datasets[1].data.push(this.wsfinder.total_daily_stats[o].total_backup)



            }
            // _.forEach(this.wsfinder.total_daily_stats, r => {
            //   // console.log(r.date, r.total_detect, r.total_backup, r.total_scan)
            //   // WSF_Detect_Total.labels.push(r.date)

            //   WSF_Detect_Total.datasets[0].data.push(r.total_detect)
            //   WSF_Detect_Total.datasets[1].data.push(r.total_backup)
            //   // WSF_Detect_Total.datasets[2].data.push(r.total_scan)
            // })
            this.WSFinder_Daily_Detection_Total = WSF_Detect_Total;

            // 3.2.2 Daily detection and isolation events by server
            this.wsfinder.agent_check_table = _.map(this.wsfinder.agent_daily_stats, r => {

              // console.log('wtf', r.host,  Math.ceil(_.maxBy(r.data, x => x ? x.total_detect : 0).total_detect), Math.ceil(_.maxBy(r.data, x => x ? x.total_detect : 0).total_detect / 10))

              r.chart = {
                labels : [],
                datasets: [
                  { yAxisID : "y-axis-detect", label: `WSFinder ${this.i18n_data['detect'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(0), 70), },
                  { yAxisID : "y-axis-base", label: `WSFinder ${this.i18n_data['isolation'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(3), 70), },
                  // { yAxisID : "y-axis-detect", label: `WSFinder ${this.i18n_data['scan'][this.i18n]}`, data: [], backgroundColor: hexToRgba(codes.WMDS_LEVEL_TO_COLOR(4), 70), }
                ],
              }
              r.options = {
                scales: {
                  yAxes : [
                    { labels : { show : true }, position : "right", id : "y-axis-detect", ticks: { stepSize : Math.ceil(_.maxBy(r.data, x => x ? x.total_detect : 0).total_detect / 10), beginAtZero : true } },
                    { labels : { show : true }, position : "left", id : "y-axis-base", ticks: { stepSize : Math.ceil(_.maxBy(r.data, x => x ? x.total_backup : 0).total_backup / 10), beginAtZero : true } }
                  ]
                }
              }


              r.options.scales.yAxes[0].ticks.stepSize = r.options.scales.yAxes[0].ticks.stepSize <= 0  ? 1 : r.options.scales.yAxes[0].ticks.stepSize
              r.options.scales.yAxes[1].ticks.stepSize = r.options.scales.yAxes[1].ticks.stepSize <= 0  ? 1 : r.options.scales.yAxes[1].ticks.stepSize

              _.map(r.data, t => r.chart.labels.push(t.date))

              let date_list = _.map(r.data, d => d.date)

              // r.chart.labels = date_list
              // console.log('date_list', date_list)

              _.forEach(search_range, day => {
                r.chart.labels.push(day)
                let index = _.findIndex(date_list, dd => dd == day)

                if(index < 0) {
                  r.chart.datasets[0].data.push(0)
                  r.chart.datasets[1].data.push(0)
                  // r.chart.datasets[2].data.push(0)
                  return
                }

                r.chart.datasets[0].data.push(r.data[index].total_detect)
                r.chart.datasets[1].data.push(r.data[index].total_backup)
                // r.chart.datasets[2].data.push(r.data[index].total_scan)

              })

              return JSON.parse(JSON.stringify(r))
            })

            console.log(this.wsfinder.agent_check_table)

            // this.WSFinder_Daily_Detection_Server = this.wsfinder_recent.wsf_daily_detection_server.map(e => {
            //   let WSF_Detect_Server = {
            //     host : e.host,
            //     series: [
            //       { name: this.i18n_data['detect'][this.i18n], data: [] },
            //       { name: this.i18n_data['isolation'][this.i18n], data: [] },
            //     ],
            //     categories : [] // 사실상 라벨임
            //   }

            //   let rs = search_range.map(day => {
            //     // 일할 데이터 넣기
            //     WSF_Detect_Server.categories.push(day)

            //     let day_result = _.filter(this.wsfinder_recent.wsf_daily_detection_server, x => x.key == e.key && _.filter(x.rs_list, info => info.day == day).length > 0)
            //     let info = day_result.length > 0 ? _.filter(day_result[0].rs_list, r => r.day == day)[0] : { cnt : 0, backup : 0 }
            //     // console.log(info.cnt, info.backup, 'info', e.key)
            //     // 탐지 따로, 백업 따로 되어 있는 부분으로 백엔드랑 데이터 맞춤 필요
            //     WSF_Detect_Server.series[0].data.push(info.cnt - info.backup - info.backup)
            //     WSF_Detect_Server.series[1].data.push(info.backup)

            //     return WSF_Detect_Server
            //   })[0]
            //   return rs
            // })

            // _.forEach(_.filter(this.wsfinder.agent_list, a => _.indexOf(this.WSFinder_Daily_Detection_Server, s => s.host == a.host) < 0), d => {
              // 빈 데이터 확인 후 넣기
              // console.log('daily empty', d.host)

              // let empty_daily = {
              //   host : d.host,
              //   series: [
              //     { name: this.i18n_data['detect'][this.i18n], data: CHART_ZERO_FILL },
              //     { name: this.i18n_data['isolation'][this.i18n], data: CHART_ZERO_FILL },
              //   ],
              //   categories : search_range // 사실상 라벨임
              // }
              // this.WSFinder_Daily_Detection_Server.push(empty_daily)


              // let empty_event = {
              //   host : d.host,
              //   category : 'N/A',
              //   code : 'N/A',
              //   path : 'N/A',
              //   created_at : '',
              //   is_backup : 'N/A',
              // }

              // TODO : 버그 발생될 수 있음
              // if(this.wsfinder.agent_list.length) {
              //   this.wsfinder.server_event.push([empty_event])
              // }

            // })

            //3.4.1.2. Daliy_update
            let WSF_Pattern_Total = {
              labels: [],
              datasets: [ { label: this.i18n_data['wsfinder_pattern_log'][this.i18n], data: [], backgroundColor: hexToRgba('#007bff', 70), } ]
            }
            _.map(this.wsfinder_recent.pattern, r => {
              WSF_Pattern_Total.labels.push(r.day)
              WSF_Pattern_Total.datasets[0].data.push(r.cnt)
            })
            this.WSFinder_Daily_Pattern = WSF_Pattern_Total;
          } catch (e) {
            console.error(e)
            this.$toastr.e("WSFinder " + this.i18n_data['generated_report_failed'][this.i18n])
          }
        } else {
          this.wsfinder = Object.assign({ web_security_configuration_status : [], summary_1_4 : [], agent_check_table : [] });
          this.wsfinder_recent = Object.assign({});
        }

        if(this.is_wf) {
            try {
              console.log('start wf')

              // WF 부분
              // 통합 차트임
              let WF_Daily_Detection_Total = {
                labels: [],
                datasets: [
                  { label: this.i18n_data['wfdetector_domain_total'][this.i18n], data: [], backgroundColor: hexToRgba(codes.WF_LEVEL_TO_COLOR(4), 50), },
                  { label: this.i18n_data['wfdetector_server_total'][this.i18n], data: [], backgroundColor: hexToRgba(codes.WF_LEVEL_TO_COLOR(5), 70), }
                ],

                options: {
                  scales: {
                    yAxes : [
                      { labels : { show : true }, position : "right", id : "y-axis-detect", ticks: { stepSize : Math.ceil(_.maxBy([].concat(this.wsfinder.total_daily_stats).concat(this.wmds_recent.wf_daily_detection_total), x => {
                        // console.log(x)
                        if(!x){ return }
                        return x.cnt != undefined ? x.cnt : x.total_forgery
                      }) / 10), beginAtZero : true } },
                      // { position : "left", id : "y-axis-base", ticks: { stepSize : 1, beginAtZero : true } }
                    ]
                  }
                }
              }

              search_range.forEach(d => {
                WF_Daily_Detection_Total.labels.push(d)

                // wmds
                if(this.wmds && this.wmds_recent && this.wmds_recent.wf_daily_detection_total.length) {

                  let index = _.findIndex(this.wmds_recent.wf_daily_detection_total, i => i.date == d)
                  WF_Daily_Detection_Total.datasets[0].data.push(index > -1 ? this.wmds_recent.wf_daily_detection_total[index].cnt : 0)
                }

                // wsfinder
                if(this.is_wsf && this.wsfinder.total_daily_stats_forgery.length) {

                  let index = _.findIndex(this.wsfinder.total_daily_stats_forgery, i => i.date == d)
                  WF_Daily_Detection_Total.datasets[1].data.push(index > -1 ? this.wsfinder.total_daily_stats_forgery[index].total_forgery : 0)
                }



              })

              this.WF_Daily_Detect_Total = WF_Daily_Detection_Total;

              // // wmds
              // _.forEach(this.wmds ? this.wmds_recent.wf_daily_detection_total : [], r => {
              //   WF_Daily_Detection_Total.labels.push(r.day)
              //   WF_Daily_Detection_Total.datasets[0].data.push(r.cnt)
              // })

              // wsfinder
              // _.forEach(this.is_wsf ? this.wsfinder.total_daily_stats_forgery : [], r => {
              //   console.log(r)
              //   this.wsfinder ? '' : WF_Daily_Detection_Total.labels.push(r.date)
              //   WF_Daily_Detection_Total.datasets[1].data.push(r.total_forgery)
              // })
              // this.WF_Daily_Detect_Total = WF_Daily_Detection_Total;

              //5.2.2.1. Daily detection
              // 일별 차트임
              _.forEach(this.wmds_recent.wf_daily_detection_domain, d => {
                d.chart = { labels : search_range, datasets: [{ label: d.fqdn, data : [ ], backgroundColor : hexToRgba(codes.WF_LEVEL_TO_COLOR(5), 70)}]}
                _.forEach(d.rs_list, t => {

                  let index = _.findIndex(d.rs_list, i => i.date == t.day)
                  d.chart.datasets[0].data.push(index > -1 ? t.cnt : 0)
                  // d.chart.datasets[0].data.push(t.cnt)

                  // d.chart.labels.push(t.day)
                  // d.chart.datasets[0].data.push(t.cnt)

                })
              })
              this.WF_Daily_detect_domain = this.wmds_recent.wf_daily_detection_domain;

              console.log('start wf 1')


              //5.2.2.2 Daily detection //
              // wsfinder
              _.forEach(this.wsfinder.agent_daily_stats, d => {
                d.chart = { labels : search_range, datasets: [{ yAxisID : "y-axis-detect", label: d.host, data : [], backgroundColor : hexToRgba(codes.WF_LEVEL_TO_COLOR(5), 90)}]}
                d.options = {
                  scales: {
                    yAxes : [
                      { labels : { show : true }, position : "right", id : "y-axis-detect", ticks: { stepSize : _.maxBy(d.data, x => x.total_forgery) / 10, beginAtZero : true } },
                      // { position : "left", id : "y-axis-base", ticks: { stepSize : 1, beginAtZero : true } }
                    ]
                  }
                }

                search_range.forEach(day => {
                  let index = _.findIndex(d.data, i => i.date == day)
                  d.chart.datasets[0].data.push(index > -1 ? d.data[index].total_forgery : 0)
                })

                // _.forEach(d.data, t => {
                //   d.chart.datasets[0].data.push(t.total_forgery)
                // })
              })

              _.forEach(this.wsfinder.agent_daily_stats_forgery, d => {
                d.chart = { labels : search_range, datasets: [{ yAxisID : "y-axis-detect", label: d.host, data : [], backgroundColor : hexToRgba(codes.WF_LEVEL_TO_COLOR(5), 90)}]}
                d.options = {
                  scales: {
                    yAxes : [
                      { labels : { show : true }, position : "right", id : "y-axis-detect", ticks: { stepSize : _.maxBy(d.data, x => x.total_forgery) / 10, beginAtZero : true } },
                      // { position : "left", id : "y-axis-base", ticks: { stepSize : 1, beginAtZero : true } }
                    ]
                  }
                }

                console.log(d, d.data)

                search_range.forEach(day => {
                  let index = _.findIndex(d.data, i => i.date == day)
                  d.chart.datasets[0].data.push(index > -1 ? d.data[index].total_forgery : 0)
                })
              })


              this.WF_Daily_detect_server = this.wsfinder.agent_daily_stats_forgery;


              console.log('start wf 2')
            } catch (e) {
              console.log(e)
              this.$toastr.e("WFDetecter " + this.i18n_data['generated_report_failed'][this.i18n])
            }
          }

          this.$toastr.s(this.i18n_data['generated_report'][this.i18n || 'EN'])
      } catch(e) {
        console.log(e)
        this.$toastr.e(this.i18n_data['generated_report_failed'][this.i18n])
      } finally {
        this.loading = false
      }
    },
    confirm_custom(date) { this.report(date.start, date.end) },
    confirm_monthly(month) { this.report() }, // console.log(month.text)
    async make_pdf_wfdetect(doc) {
      console.log("start wf")

      try {

        doc.addPage(0, true) // 강제 페이지 나눔

        // addSubTitle(`${this.start_wf}. Web Forgery Detection`, 0)
        // addSubTitle(`${this.start_wf}.1. Summmary`, 1)
        // addSubTitle(`${this.start_wf}.1.1. General Information`, 2)

        doc.addSubTitle(this.get_index_title(), 0)
        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)

        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['username'][this.i18n], auth.profile.username ],
            [ this.i18n_data['report_period'][this.i18n], this.from + ' ~ ' + this.to ]
          ]
        })

        // addSubTitle(`${this.start_wf}.1.2. WFDetector Status`, 2)

        doc.addSubTitle(this.get_index_title(), 2)

        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['status'][this.i18n], { content: this.i18n_data['count'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } } ],
            [ this.i18n_data['contract'][this.i18n], (
                ((this.wmds_summary && this.wmds_summary.wf_detector_stauts) ? this.wmds_summary.wf_detector_stauts.count : 0) +
                ((this.wsfinder && this.wsfinder.wf_agent_list) ? this.wsfinder.wf_agent_list.length : 0)
              )
            ]
          ]
        })

        // addSubTitle(`${this.start_wf}.1.3. Total number of security events`, 2)

        doc.addSubTitle(this.get_index_title(), 2)

        doc.dataBody = []
        if(this.wmds_summary && this.wmds_summary.wf_total_number_of_security_events) {
          doc.dataBody.push(['WMDS', this.wmds_summary.wf_total_number_of_security_events.count || 0])
        }
        if(this.wsfinder && this.wsfinder.total_forgery && this.wsfinder.total_forgery) {
          doc.dataBody.push(['WSFinder', this.wsfinder.total_forgery || 0])
        }

        if(
          (this.wmds_summary && this.wmds_summary.wf_total_number_of_security_events && this.wmds_summary.wf_total_number_of_security_events.type < 1 &&
            this.wsfinder && this.wsfinder.total_forgery && this.wsfinder.total_forgery.type < 1) ||
            !this.wmds_summary || !this.wsfinder
        ) {
          doc.dataBody.push([ 'N/A', 'N/A' ])
        }

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [ this.i18n_data['event'][this.i18n], this.i18n_data['count'][this.i18n] ]
          ],
          body: doc.dataBody
        })


        // addSubTitle(`${this.start_wf}.1.4. Web Server & WFDetector Status`, 2)
        doc.addSubTitle(this.get_index_title(), 2)

        doc.dataBody = []

        if (this.wsfinder && this.wsfinder.wf_agent_list.length > 0) {
          this.wsfinder.wf_agent_list.forEach((WF_5_1_4)=> {
            doc.dataBody.push([ WF_5_1_4.name, WF_5_1_4.host, WF_5_1_4.ip_addr_private  ])
          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A', 'N/A' ])
        }

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [ { content: 'WSFinder ' + this.i18n_data['server'][this.i18n], colSpan: 3 } ],
            [ this.i18n_data['name'][this.i18n], this.i18n_data['host'][this.i18n],  this.i18n_data['ip'][this.i18n] ]
          ],
          body: doc.dataBody
        })

        // addSubTitle(`${this.start_wf}.1.5. Domain & WFDetector Status`, 2)

        doc.addSubTitle(this.get_index_title(), 2)

        doc.dataBody = []

        if (this.wmds_summary && this.wmds_summary.domain_and_wf_detector_status.length > 0) {
          this.wmds_summary.domain_and_wf_detector_status.forEach((WF_5_1_5) => {
            doc.dataBody.push([ WF_5_1_5.name, WF_5_1_5.fqdn ])
          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A' ])
        }

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [ { content: 'WMDS '+this.i18n_data['domain'][this.i18n], colSpan: 2 } ],
            [ this.i18n_data['name'][this.i18n], this.i18n_data['fqdn'][this.i18n] ]
          ],
          body: doc.dataBody
        })

        // 위변조 부분 리포팅 시작
        doc.addPage(0, true) // 강제 페이지 나눔

        // addSubTitle(`${this.start_wf}.2. Monitoring Status`, 1)
        // addSubTitle(`${this.start_wf}.2.1. Daily detection events by Total`, 2)
        // addSubTitle(`${this.start_wf}.2.1.1. Daily detection (Total)`, 3)

        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)

        await doc.addChart(this.WF_Daily_Detect_Total, 3, 160, 80, 'line', this.WF_Daily_Detect_Total.options)

        doc.addPage(0, true) // 강제 페이지 나눔

        // addSubTitle(`${this.start_wf}.2.2. Daily detection events by individual`, 2)

        doc.addSubTitle(this.get_index_title(), 2)

        if (this.WF_Daily_detect_server && this.WF_Daily_detect_server.length > 0) {
          for(let i = 0; i < this.WF_Daily_detect_server.length; i++) {

            // addSubTitle(`${this.start_wf}.2.2.${i + 1}. Daily detection of server (${this.WF_Daily_detect_server[i].host})`, 3)

            doc.addSubTitle(this.get_index_title(), 3)

            await doc.addChart(this.WF_Daily_detect_server[i].chart, 3, 160, 80, 'line', this.WF_Daily_detect_server[i].options)
            if(i > 0 && i % 2 == 0) {
              doc.addPage(0, true) // 강제 페이지 나눔
            } else {
              doc.addSpacing(3)
            }
          }
        } else {
          // 빈 차트 넣어야 함
          await doc.addChart(this.blank_chart_data, 3, 160, 80)
        }
        doc.addPage(0, true) // 강제 페이지 나눔

        if (this.WF_Daily_detect_domain && this.WF_Daily_detect_domain.length > 0) {
          for(let i = 0; i < this.WF_Daily_detect_domain.length; i++ ) {

            doc.addSubTitle(`${this.start_wf}.2.2.${(i + (this.WF_Daily_detect_server || []).length + 1)}. ${this.i18n_data['daily_domain_detect'][this.i18n]} (${this.WF_Daily_detect_domain[i].fqdn})`, 3)

            doc.addSubTitle(this.get_index_title(), 3)

            await doc.addChart(this.WF_Daily_detect_domain[i].chart, 3, 160, 80)
            if(i > 0 && i % 2 == 0) {
              doc.addPage(0, true) // 강제 페이지 나눔
            } else {
              doc.addSpacing(3)
            }
          }
        }

        doc.addPage(0, true) // 강제 페이지 나눔

        // addSubTitle(`${this.start_wf}.2.3. Detection events per domain`, 2)
        // addSubTitle(`${this.start_wf}.2.3.1. Total number per domain`, 3)

        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)

        doc.dataBody = []

        if (this.wsfinder && this.wsfinder.wf_agent_list && this.wsfinder.wf_agent_list.length > 0) {
          this.wsfinder.wf_agent_list.forEach((WF_5_2_3_1) => {
            doc.dataBody.push([ WF_5_2_3_1.name, (WF_5_2_3_1.total_forgery || 0) ])
          })
        }

        if (this.wmds_summary && this.wmds_summary.wf_total_number_per_domain && this.wmds_summary.wf_total_number_per_domain.length > 0) {
          this.wmds_summary.wf_total_number_per_domain.forEach((WF_5_2_3_1) => {
            doc.dataBody.push([ WF_5_2_3_1.fqdn, (WF_5_2_3_1.count || 0) ])
          })
        }

        if(doc.dataBody.length < 1) { doc.dataBody.push([ 'N/A', 'N/A']) }

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [ { content: this.i18n_data['domain_and_server'][this.i18n], styles : { valign : 'middle' }, rowSpan: 2 }, this.i18n_data['event'][this.i18n] ],
            [ this.i18n_data['detect'][this.i18n] ]
          ],
          body: doc.dataBody
        })

        // TODO : 아래 부분은 현재 하지 않음, PDF 서비스에서는 해야 함

        // addSubTitle(`${this.start_wf}.2.3.2. Events (Total)`, 3)

        // doc.addSubTitle(this.get_index_title(), 3)

        // doc.dataBody = []

        // if (this.wsfinder && this.wsfinder.wf_total_detection && this.wsfinder.wf_total_detection.length > 0) {
        //   this.wsfsinder.wf_total_detection.forEach((WF_5_2_3_2) => {
        //     doc.dataBody.push([ WF_5_2_3_2.name, WF_5_2_3_2.type, WF_5_2_3_2.type, (WF_5_2_3_2.action ? WF_5_2_3_2.action : this.i18n_data['changed'][this.i18n]), WF_5_2_3_2.target, moment(WF_5_2_3_2.created_at).format("YYYY-MM-DD") ])
        //   })
        // }

        // if (this.wmds_summary && this.wmds_summary.wf_total_detection && this.wmds_summary.wf_total_detection.length > 0) {
        //   this.wmds_summary.wf_total_detection.forEach((WF_5_2_3_2) => {
        //     doc.dataBody.push([ WF_5_2_3_2.name, WF_5_2_3_2.type, WF_5_2_3_2.type, (WF_5_2_3_2.action ? this.i18n_data['changed'][this.i18n] : this.i18n_data['changed'][this.i18n]), WF_5_2_3_2.target, moment(WF_5_2_3_2.created_at).format("YYYY-MM-DD") ])
        //   })
        // }

        // if(doc.dataBody.length < 1) {
        //   doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
        // }

        // await doc.addTable({
        //   headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
        //   columnStyles: {
        //     0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     4: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //   },
        //   head: [
        //     [ this.i18n_data['name'][this.i18n], this.i18n_data['category'][this.i18n], this.i18n_data['pattern'][this.i18n], this.i18n_data['path'][this.i18n], this.i18n_data['detect_time'][this.i18n] ],
        //   ],
        //   body: doc.dataBody
        // })

        // doc.dataBody = []

        // if (this.wmds_summary && this.wmds_summary.wf_events_domain && this.wmds_summary.wf_events_domain.length > 0) {
        //   this.wmds_summary.wf_events_domain.forEach(async (WF_5_2_3_3) => {

        //     // addSubTitle(`${this.start_wf}.2.3.3. Events (${WF_5_2_3_3.fqdn})`, 3)

        //     doc.addSubTitle(this.get_index_title(), 3)

        //     if (WF_5_2_3_3.rs_list.length > 0) {
        //       WF_5_2_3_3.rs_list.forEach((WF_5_2_3_3_1) => {
        //         doc.dataBody.push([ WF_5_2_3_3_1.type, (WF_5_2_3_3_1.action ? this.i18n_data['changed'][this.i18n] : this.i18n_data['changed'][this.i18n]), WF_5_2_3_3_1.target, moment(WF_5_2_3_3_1.created_at).format("YYYY-MM-DD") ])
        //       })
        //     }

        //     await doc.addTable({
        //       headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
        //       columnStyles: {
        //         0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //         1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //         2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //         3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
        //       },
        //       head: [
        //         [ this.i18n_data['type'][this.i18n], this.i18n_data['action'][this.i18n], this.i18n_data['target'][this.i18n], this.i18n_data['detect_time'][this.i18n] ],
        //       ],
        //       body: doc.dataBody
        //     })
        //   })
        // }

        // if (this.wsfinder_summary && this.wsfinder_summary.wf_events_server && this.wsfinder_summary.wf_events_server.length > 0) {
        //   this.wsfinder_summary.wf_events_server.forEach(async (WF_5_2_3_4) => {

        //     // addSubTitle(`${this.start_wf}.2.3.4. Events (${WF_5_2_3_4.host})`, 3)

        //     doc.addSubTitle(this.get_index_title(), 3)

        //     doc.dataBody = []

        //     if (WF_5_2_3_4.rs_list.length > 0) {
        //       WF_5_2_3_4.rs_list.forEach((WF_5_2_3_4_1) => {
        //         doc.dataBody.push([ WF_5_2_3_4_1.type, (WF_5_2_3_4_1.action ? WF_5_2_3_4_1.action : this.i18n_data['changed'][this.i18n]), WF_5_2_3_4_1.target, moment(WF_5_2_3_4_1.created_at).format("YYYY.MM.DD") ])
        //       })
        //     }

        //     await doc.addTable({
        //       headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
        //       columnStyles: {
        //         0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //         1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //         2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //         3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
        //       },
        //       head: [
        //         [ this.i18n_data['type'][this.i18n], this.i18n_data['action'][this.i18n], this.i18n_data['target'][this.i18n], this.i18n_data['detect_time'][this.i18n] ],
        //       ],
        //       body: doc.dataBody
        //     })
        //   })
        // }
      } catch (e) {
        console.log(e)
        console.log('[-] generate report wfdetect part failed')
        this.$toastr.w('generate report wfdetect part failed')
      }
      return doc
    },
    async make_pdf_wmds(doc) {
      console.log("start wmds")
      try {

        doc.addPage(0, true) // 강제 페이지 나눔

        doc.addSubTitle(this.get_index_title(), 0)
        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)

        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['username'][this.i18n], auth.profile.username ],
            [ this.i18n_data['report_period'][this.i18n], this.from + ' ~ ' + this.to ]
          ]
        })

        // addSubTitle(`${this.start_wmds}.1.2. WMDS Status`, 2)

        doc.addSubTitle(this.get_index_title(), 2)

        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['status'][this.i18n], { content: this.i18n_data['count'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } } ],
            [ this.i18n_data['contract'][this.i18n], (this.wmds.site_list_alive ? number(this.wmds.site_list_alive.length) : 0) ]
          ]
        })

        // addSubTitle(`${this.start_wmds}.1.3. Total number of security events`, 2)

        doc.addSubTitle(this.get_index_title(), 2)


        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['event'][this.i18n], { content: this.i18n_data['count'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } } ],
            [ this.i18n_data['scan'][this.i18n], (this.wmds && this.wmds.total_scan  ? number(this.wmds.total_scan) : 0) ],
            [ this.i18n_data['page'][this.i18n], (this.wmds && this.wmds.total_page  ? number(this.wmds.total_page) : 0) ],
            [ this.i18n_data['detect'][this.i18n], (this.wmds && this.wmds.total_detect  ? number(this.wmds.total_detect) : 0) ]
          ]
        })

        // 도메인 & 악성코드 유포,경유지 탐지 현황
        // etailed status of monitoring of d
        doc.addSubTitle(this.get_index_title(), 2)

        doc.dataBody = []

        if(this.wmds.site_list.length > 0) {
          this.wmds.site_list.forEach((WMDS_5_1_4) => {
            doc.dataBody.push([
              WMDS_5_1_4.name,
              WMDS_5_1_4.fqdn,
              {
                content : WMDS_5_1_4.is_del ? this.i18n_data['off'][this.i18n] : this.i18n_data['on'][this.i18n],
                styles : {
                  textColor : WMDS_5_1_4.is_del ? '#c8ced2' : '#4dbe74'
                }
              },
              { content : WMDS_5_1_4.is_del ? moment(WMDS_5_1_4.deleted_at).format('YYYY-MM-DD hh:mm:ss') : '-' }
            ])

          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A' ])
        }

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [ { content: this.i18n_data['domain'][this.i18n], colSpan: 4 } ],
            [ this.i18n_data['name'][this.i18n], this.i18n_data['fqdn'][this.i18n], this.i18n_data['status'][this.i18n], this.i18n_data['deleted'][this.i18n] ]
          ],
          body: doc.dataBody
        })

        doc.addPage(0, true) // 강제 페이지 나눔

        // 모니터링 현황
        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)

        await doc.addChart(this.WMDS_Daily_Detecting, 3, 160, 80, 'line', this.WMDS_Daily_Detecting.options)

        doc.addPage(0, true) // 강제 페이지 나눔
        // doc.addSpacing(5)

        // addSubTitle(`${this.start_wmds}.2.2. Daily detection events by individual`, 2)
        doc.addSubTitle(this.get_index_title(), 2)

        // chartFunctions = []
        if (this.wmds.domain_check_table.length > 0) {
          for (let i = 0; i < this.wmds.domain_check_table.length; i++) {
            const WMDS_5_2_2_1 = this.wmds.domain_check_table[i];

            // 일일 탐지
            doc.addSubTitle(this.get_index_title(), 3)
            await doc.addChart(WMDS_5_2_2_1.chart, 3, 160, 80, 'line', WMDS_5_2_2_1.chart.options)

            // if(index > 0 && index % 2 == 0) {
            if((i - 1) % 2 == 0) {
              doc.addPage(0, true) // 강제 페이지 나눔
            } else {
              doc.addSpacing(2)
            }
          }
        } else {
          await doc.addChart(this.blank_chart_data, 3, 160, 80)
        }

        doc.addPage(0, true)
        // doc.addSpacing(10)

        // 서버 / 도메인 탐지 이벤트
        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)

        doc.dataBody = []

        if (this.wmds.top_n_detect_domain.length > 0) {
          this.wmds.top_n_detect_domain.forEach((WMDS_5_2_3_1) => {
            doc.dataBody.push([ `${WMDS_5_2_3_1.name}(${WMDS_5_2_3_1.domain})`, WMDS_5_2_3_1.data.length ])
          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A' ])
        }

        //  상위 10개 이벤트
        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [ { content: this.i18n_data['domain_fqdn'][this.i18n], rowSpan: 2, styles : { valign : 'middle' } }, this.i18n_data['event'][this.i18n] ],
            [ this.i18n_data['detect'][this.i18n] ]
          ],
          body: doc.dataBody
        })

        doc.addPage(0, true)

        // 상위 10개 이벤트 (Total)
        // doc.addSubTitle(this.get_index_title(), 3)

        doc.dataBody = []

        // if (this.wmds.events_total.length > 0) {
        //   this.wmds.events_total.forEach((WMDS_5_2_4_2_Total) => {
        //     doc.dataBody.push([ WMDS_5_2_4_2_Total.fqdn, WMDS_5_2_4_2_Total.code, WMDS_5_2_4_2_Total.url ])
        //   })
        // } else {
        //   doc.dataBody.push([ 'N/A', 'N/A', 'N/A' ])
        // }

        // await doc.addTable({
        //   headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
        //   columnStyles: {
        //     0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     1: { fontStyle: 'bold', halign: 'center', cellWidth: 70, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     2: { fontStyle: 'bold', halign: 'center', cellWidth: 70, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
        //   },
        //   head: [
        //     [ this.i18n_data['name'][this.i18n], this.i18n_data['code'][this.i18n], 'URL' ]
        //   ],
        //   body: doc.dataBody
        // })

        // this.wmds && this.wmds.top_n_detect_domain.length ? doc.addPage(0, true) : '' // 강제 페이지 나눔

        let count = 0
        for(let i=0; i < this.wmds.top_n_detect_domain.length; i++) {
          if(count >= 20) {
            doc.addPage(0, true)
            count = 0
          }
          // addSubTitle(`${this.start_wmds}.2.3.${i + 2 + 1} Events (${this.wmds.top_n_detect_domain[i].fqdn})`, 3)
          doc.addSubTitle(this.get_index_title(), 3)

          doc.dataBody = []
          let is_has = false
          for(let j=0; j < this.wmds.top_n_detect_domain[i].data.length; j++) {
            let WMDS_4_2_3 = this.wmds.top_n_detect_domain[i].data[j]

            doc.dataBody.push([
              { content : codes.WMDS_TYPE[WMDS_4_2_3.type], rowSpan : 2, styles : { valign : 'middle' } },
              { content : codes.WMDS_PATTRN_LEVEL[WMDS_4_2_3.level], rowSpan : 2, styles : { valign : 'middle' } },
              { content : "Code" },
              { content : WMDS_4_2_3.code },
            ])

            doc.dataBody.push([
              { content : "URL" },
              { content : WMDS_4_2_3.url }
            ])



            is_has = true
          }
          if(is_has == false) { doc.dataBody.push([ 'N/A', 'N/A', 'N/A']); count += 3 }

          await doc.addTable({
            headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
            columnStyles: {
              0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            },
            head: [
              [
                { content : this.i18n_data['type'][this.i18n], rowSpan : 1 },
                { content : this.i18n_data['risk'][this.i18n], rowSpan : 1 },
                { content : this.i18n_data['detail'][this.i18n], colSpan : 2 }
                // rowSpan : 2
              ]
            ],
            body: doc.dataBody
          })

          count += this.wmds.top_n_detect_domain[i].data.length


          // 깨질경우 테이블 간격 조정하는 부분 추가 해야 함
        }

        doc.addPage(0, true) // 강제 페이지 나눔

        // 관리 현황
        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
          },
          head: [
            [ { content: this.i18n_data['pattern'][this.i18n], colSpan: 2 } ],
            [ this.i18n_data['total'][this.i18n], this.i18n_data['this_month'][this.i18n]]
          ],
          body: [
            [
              this.wmds && this.wmds.pattern ? number(this.wmds.pattern.total) : 0,
              this.wmds && this.wmds.pattern ? number(this.wmds.pattern.updated) : 0
            ]
          ]
        })

        // addSubTitle(`${this.start_wmds}.3.1.2. Daily updates`, 3)
        // await doc.addChart(this.WMDS_Daily_Pattern, 3, 160, 80)

        // addSubTitle(`${this.start_wmds}.3.1.2. Updated pattern description`, 3)
        doc.addSubTitle(this.get_index_title(), 3)

        doc.dataBody = []

        if (this.wmds.pattern.pattern_list.length > 0) {
          this.wmds.pattern.pattern_list.forEach((WMDS_5_4_1_3) => {
            doc.dataBody.push([ moment(WMDS_5_4_1_3.create_at).format("YYYY-MM-DD"), codes.WMDS_PATTRN_LEVEL[WMDS_5_4_1_3.level], WMDS_5_4_1_3.code ])
          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A', 'N/A' ])
        }

        await doc.addTable({
            headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
            columnStyles: {
              0: {  fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              1: {  fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              2: {  fontStyle: 'bold', halign: 'left', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
            },
            head: [
              [this.i18n_data['date'][this.i18n], this.i18n_data['level'][this.i18n], this.i18n_data['code'][this.i18n]]
            ],
            body: doc.dataBody
        })
      } catch (e) {
        console.log(e)
        console.log('[-] generate report wmds part failed')
        this.$toastr.w('generate report wmds part failed')
      }
      return doc
    },
    async make_pdf_wsfinder(doc) {
      console.log("start wsf")
      try {

        doc.addPage(0, true) // 강제 페이지 나눔
        // addSubTitle(`${this.start_wsf}. Webshell detection & isolation (WSFinder)`, 0)
        // addSubTitle(`${this.start_wsf}.1. Summary`, 1)
        // addSubTitle(`${this.start_wsf}.1.1. General Information`, 2)

        doc.addSubTitle(this.get_index_title(), 0)
        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)  // 기본 정보

        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['username'][this.i18n], auth.profile.username ],
            [ this.i18n_data['report_period'][this.i18n], this.from + ' ~ ' + this.to ]
          ]
        })

        // 웹쉘 탐지 현황
        doc.addSubTitle(this.get_index_title(), 2)
        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['status'][this.i18n], { content: this.i18n_data['count'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } } ],
            [ this.i18n_data['contract'][this.i18n], (this.wsfinder ? this.wsfinder.agent_list.length : 0) ]
          ]
        })

        // 탐지 이벤트 현황
        doc.addSubTitle(this.get_index_title(), 2)
        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
          },
          body: [
            [ this.i18n_data['event'][this.i18n], { content: this.i18n_data['count'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } } ],
            [ this.i18n_data['scan'][this.i18n], (this.wsfinder.total_scan ? this.wsfinder.total_scan : 0) ],
            [ this.i18n_data['file'][this.i18n], (this.wsfinder.total_file ? this.wsfinder.total_file : 0) ],
            [ this.i18n_data['detect'][this.i18n], (this.wsfinder.total_detect ? this.wsfinder.total_detect : 0) ],
            [ this.i18n_data['backup'][this.i18n], (this.wsfinder.total_backup ? this.wsfinder.total_backup : 0) ],
          ]
        })


        // 웹 서버 & 웹쉘 탐지 현황
        doc.addPage(0, true) // 강제 페이지 나눔
        doc.addSubTitle(this.get_index_title(), 2)

        doc.dataBody = []

        if (this.wsfinder.agent_list.length > 0) {
          let index = 0
          this.wsfinder.agent_list.forEach((WSF_3_1_4) => {
            doc.dataBody.push([
              (++index),
              WSF_3_1_4.host,
              `${WSF_3_1_4.ip_addr_public} / ${WSF_3_1_4.ip_addr_private}`,
              WSF_3_1_4.os_type,
              (WSF_3_1_4.is_del ? this.i18n_data['off'][this.i18n] : this.i18n_data['on'][this.i18n]) // +`(${this.i18n_data['deleted'][this.i18n]})`
            ])
          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
        }

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            3: { fontStyle: 'bold', halign: 'center', cellWidth: 20, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            4: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [ { content: this.i18n_data['count'][this.i18n], colSpan: 5 } ],
            [ this.i18n_data['no'][this.i18n], this.i18n_data['name'][this.i18n], 'IP', 'OS', this.i18n_data['status'][this.i18n] ]
          ],
          body: doc.dataBody
        })


        doc.addPage(0, true) // 강제 페이지 나눔

        // addSubTitle(`${this.start_wsf}.2. Monitoring Status`, 1)
        // addSubTitle(`${this.start_wsf}.2.1. Daily detection and isolation events by Total`, 2)
        // addSubTitle(`${this.start_wsf}.2.1.1. Daily detection and isolation (Total)`, 3)
        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)


        await doc.addChart(this.WSFinder_Daily_Detection_Total, 3, 160, 80, 'line', this.WSFinder_Daily_Detection_Total.options)

        doc.addPage(0, true)
        // doc.addSubTitle(`${this.start_wsf}.2.1.2. Events (Total)`, 3)
        // doc.addSubTitle(this.get_index_title(), 3)

        doc.dataBody = []

        // for(let j=0; j < this.wsfinder.total_event.length; j++) {
        //   let WSF_3_2_3_2 = this.wsfinder.total_event[j]

        //   doc.dataBody.push([
        //     WSF_3_2_3_2.category,
        //     WSF_3_2_3_2.code,
        //     WSF_3_2_3_2.path,
        //     moment(WSF_3_2_3_2.created_at).format("YYYY-MM-DD"),
        //     {
        //       content : WSF_3_2_3_2.is_backup ? 'O' : 'X',
        //       styles : { textColor : WSF_3_2_3_2.is_backup ? '#4dbe74' : '#ed1c24' }
        //     },
        //   ])
        // }

        // if(this.wsfinder_summary.total_event.length < 1) {
        //   doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
        // }

        // // 상위 50개 이벤트 (Total)
        // await doc.addTable({
        //   headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
        //   columnStyles: {
        //     0: { fontStyle: 'bold', halign: 'center', cellWidth: 14, cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
        //     1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
        //     2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
        //     3: { fontStyle: 'bold', halign: 'center', cellWidth: 25, cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
        //     4: { fontStyle: 'bold', halign: 'center', cellWidth: 20, cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
        //   },
        //   head: [
        //     [ this.i18n_data['category'][this.i18n], this.i18n_data['pattern'][this.i18n], this.i18n_data['path'][this.i18n], this.i18n_data['detect_time'][this.i18n], this.i18n_data['isolation'][this.i18n] ]
        //   ],
        //   body: doc.dataBody
        // })

        // doc.addPage(0, true) // 강제 페이지 나눔

        // addSubTitle(`${this.start_wsf}.2.2. Daily detection and isolation events by server`, 2)
        doc.addSubTitle(this.get_index_title(), 2)

        // console.log('this.wsfinder', this.wsfinder)

        for (let k = 0; k < this.wsfinder.agent_check_table.length; k++) {

          // 어글리 하지만 백엔드 수정으로 임시 break
          if(k + 1 > this.wsfinder.agent_check_table.length) { break }

          let row = this.wsfinder.agent_check_table[k]
          // addSubTitle(`${this.start_wsf}.2.2.${k+1} Daily detection and isolation (${row.host})`, 3)
          doc.addSubTitle(this.get_index_title(), 3)

          // let data = {
          //   datasets : [
          //     { label : this.i18n_data['detect'][this.i18n], data : row.chart.datasets[0].data, backgroundColor: hexToRgba('#3D63BA', 70) },
          //     { label : this.i18n_data['isolation'][this.i18n], data : row.chart.datasets[1].data, backgroundColor: hexToRgba('#00e396', 70) }
          //   ],
          //   labels : row.chart.labels,
          // }

          // await doc.addChart(data, 3, 160, 80, 'bar', { responsive: false, animation: { duration: 0 }, scales:{ xAxes: [{ stacked: true }], yAxes: [{ stacked: true }] } })
          await doc.addChart(row.chart, 3, 160, 80, 'line', row.options)

          if(k > 0 && k % 2 == 1) {
            doc.addPage(0, true) // 강제 페이지 나눔
          } else {
            doc.addSpacing(2)
          }
        }

        if(!this.wsfinder.agent_check_table.length) {
          // 빈 차트 넣어줘야함
          // await doc.addChart(this.blank_chart_data, 3, 160, 80, 'bar', { responsive: false, animation: { duration: 0 }, scales:{ xAxes: [{ stacked: true }], yAxes: [{ stacked: true }] } })
          await doc.addChart(this.blank_chart_data)
        }

        doc.dataBody = []

        if (this.wsfinder.agent_list.length > 0) {
          this.wsfinder.agent_list.forEach((WSF_3_2_3_1) => {
            doc.dataBody.push([
              WSF_3_2_3_1.host,
              WSF_3_2_3_1.total_detect,
              WSF_3_2_3_1.total_backup
            ])
          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A' ])
        }

        doc.addPage(0, true)
        // doc.addSpacing(5)

        // 서버별 탐지 및 격리
        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            4: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          head: [
            [
              { content : this.i18n_data['server_name'][this.i18n], rowSpan : 2, styles : { valign : 'middle' }},
              { content : this.i18n_data['event'][this.i18n], colSpan : 2  },
            ],
            [
              { content : this.i18n_data['detect'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
              { content : this.i18n_data['isolation'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
            ]
          ],
          body: doc.dataBody
        })
        doc.dataBody = []


        doc.addPage(0, true) // 강제 페이지 나눔

        // 상위 10개 이벤트(서버별)
        let count = 0
        for(let i=0; i < this.wsfinder.top_n_detect_agent.length; i++) {
          if(count >= 20) {
            doc.addPage(0, true) // 강제 페이지 나눔
            count = 0
          }
          doc.addSubTitle(this.get_index_title(), 3)
          doc.dataBody = []
          for(let j=0; j < this.wsfinder.top_n_detect_agent[i].data.length; j++) {
            let WSF_3_2_3_3 = this.wsfinder.top_n_detect_agent[i].data[j]
            console.log('WSF_3_2_3_3', WSF_3_2_3_3)

            doc.dataBody.push([
              WSF_3_2_3_3.type,
              WSF_3_2_3_3.value || WSF_3_2_3_3.code,
              WSF_3_2_3_3.path,
              WSF_3_2_3_3.created_at ? moment(WSF_3_2_3_3.created_at).format("YYYY-MM-DD") : '-',
              {
                content : WSF_3_2_3_3.is_backup ? 'O' : 'X',
                styles : {
                  textColor : WSF_3_2_3_3.is_backup ? '#4dbe74' : '#ed1c24'
                }
              },
            ])

            count += this.wsfinder.top_n_detect_agent[i].length
          }

          if(this.wsfinder.top_n_detect_agent[i].length < 1) {
            count += 5 // 보정용
            doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
          }

          // 상위 10개 이벤트
          await doc.addTable({
            headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
            columnStyles: {
              0: { cellWidth: 12, minCellWidth : 10, fontStyle: 'bold', halign: 'center', cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
              1: { cellWidth: 40, minCellWidth : 30, fontStyle: 'bold', halign: 'center', cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
              2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
              3: { cellWidth: 18, minCellWidth : 15, fontStyle: 'bold', halign: 'center', cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
              4: { cellWidth: 15, minCellWidth : 10, fontStyle: 'bold', halign: 'center', cellHeight: 'auto', lineWidth: 0.2, lineColor: '#000', fontSize : 8 },
            },
            head: [
              [ this.i18n_data['category'][this.i18n], this.i18n_data['detected_value'][this.i18n], this.i18n_data['path'][this.i18n], this.i18n_data['detect_time'][this.i18n], this.i18n_data['isolation'][this.i18n] ]
            ],
            body: doc.dataBody
          })
        }

        // addSpacing(10)
        doc.addPage(0, true) // 강제 페이지 나눔

        // 관리 현황
        doc.addSubTitle(this.get_index_title(), 1)
        doc.addSubTitle(this.get_index_title(), 2)
        doc.addSubTitle(this.get_index_title(), 3)

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
          },
          head: [
            [{ content : this.i18n_data['pattern'][this.i18n], colSpan: 2 }]
            ,
          ],
          // [
          //   [ '', this.i18n_data['total'][this.i18n], this.i18n_data['updated'][this.i18n]]
          // ],
          body: [
            // [
            //   { content : this.i18n_data['pattern'][this.i18n], colSpan : 3 },
            // ],
            [
              this.i18n_data['total'][this.i18n],
              this.i18n_data['updated'][this.i18n],
            ],
            [
              (this.wsfinder && this.wsfinder.pattern && this.wsfinder.pattern.total || '0'),
              (this.wsfinder && this.wsfinder.pattern && this.wsfinder.pattern.updated || '0')
            ]
          ]
        })

        // addSubTitle(`${this.start_wsf}.3.1.2. Daily updates`, 3)
        // await doc.addChart(this.WSFinder_Daily_Pattern, 3, 160, 80)

        doc.dataBody = []
        // 지금은 사용 안함, 그러나 룰 서버 업데이트 될 경우 활용될 예정
        // https://its.f1security.co.kr/issues/3181

        if (this.wsfinder.pattern.pattern_list.length > 0) {
          this.wsfinder.pattern.pattern_list.forEach((WSF_3_4_1_3) => {
            doc.dataBody.push([
              moment(WSF_3_4_1_3.created_at).format("YYYY-MM-DD"),
              codes.code_category[WSF_3_4_1_3.category] || '-',
              codes.WSFINDER_CODE_TYPE[WSF_3_4_1_3.type],
              (WSF_3_4_1_3.code ? WSF_3_4_1_3.code.slice(0, WSF_3_4_1_3.code.length < 30 ? WSF_3_4_1_3.code.length : 30) : '-')
            ])
          })
        } else {
          doc.dataBody.push( ['N/A', 'N/A', 'N/A', 'N/A' ])
        }

        // 업데이트 패턴 설명
        doc.addSubTitle(this.get_index_title(), 3)

        await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', cellWidth: 25, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 25, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            2: { fontStyle: 'bold', halign: 'center', cellWidth: 25, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
          },
          head: [
            [this.i18n_data['date'][this.i18n], this.i18n_data['category'][this.i18n], this.i18n_data['type'][this.i18n], this.i18n_data['code'][this.i18n]],
          ],
          body: doc.dataBody
        })
    } catch (e) {
        console.log(e)
        console.log('[-] generate report wsfinder part failed')
        this.$toastr.w('generate report wsfinder part failed')
      }
      return doc
    },
    async make_pdf_webcastle(doc, numbersOfSummary) {
      console.log("start wc")
      try {
        doc.addPage(0, true) // 강제 페이지 나눔

        // 2. Web Hacking Attack Detection & Blocking (WEBCastle)
        await doc.addSubTitle(this.get_index_title(), 0)

        // 2. Web Hacking Attack Detection & Blocking (WEBCastle) > 2.1. Summary
        await doc.addSubTitle(this.get_index_title(), 1)

        // 2. Web Hacking Attack Detection & Blocking (WEBCastle) > 2.1. Summary > 2.1.1. General Information
        await doc.addSubTitle(this.get_index_title(), 2)
        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['username'][this.i18n], auth.profile.username ],
            [ this.i18n_data['report_period'][this.i18n], this.from + ' ~ ' + this.to ]
          ]
        })

        // 2. Web Hacking Attack Detection & Blocking (WEBCastle) > 2.1. Summary > 2.1.2. WEBCastle Status
        await doc.addSubTitle(this.get_index_title(), 2)
        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['status'][this.i18n], { content: this.i18n_data['count'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } } ],
            [ this.i18n_data['contract'][this.i18n], (this.webcastle && this.webcastle.agent_list ? this.webcastle.agent_list.length : 0) ]
          ]
        })


        // 2. Web Hacking Attack Detection & Blocking (WEBCastle) > 2.1. Summary > 2.1.3. Total number of security events
        await doc.addSubTitle(this.get_index_title(), 2)
        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['event'][this.i18n], { content: this.i18n_data['count'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } } ],
            [ this.i18n_data['detect'][this.i18n], (this.webcastle && this.webcastle ? this.webcastle.total_detect : 0) ],
            [ this.i18n_data['block'][this.i18n], (this.webcastle && this.webcastle ? this.webcastle.total_block : 0) ],
          ]
        })

        // 2.1.4. Web Server & WEBCastle Status
        doc.dataBody.push([
          { content: this.i18n_data['server'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' }, colSpan : 4 },
        ])
        doc.dataBody.push([
          { content: this.i18n_data['name'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['ip'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['status'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['deleted'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } },
        ])

        if (numbersOfSummary['castle'] > 0) {
          this.webcastle.agent_list.forEach((WC_2_1_4) => {

            let row = [
              { content : WC_2_1_4.name },
              { content: WC_2_1_4.host },
              { content: WC_2_1_4.is_del ? 'Off' : 'On', styles : { textColor: WC_2_1_4.is_del ? '#aaa' : '#5c7' } },
              { content: WC_2_1_4.is_del ? moment(WC_2_1_4.deleted_at).format('YYYY-MM-DD') : '-' },
            ]
            doc.dataBody.push(row)
          })
        } else {
          doc.dataBody.push([ 'N/A', 'N/A', 'N/A', { content: 'N/A', colSpan: 2 } ])
        }

        await doc.addSubTitle(this.get_index_title(), 2)
        await doc.addTable({
          columnStyles: {
            0: { fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1 },
            1: { fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1 },
            2: { fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1 },
            3: { fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1 },
          },
          body: doc.dataBody
        })
        doc.dataBody = [] // 초기화

        // 2. Web Hacking Attack Detection & Blocking (WEBCastle) > 2.1. Summary > 2.1.5. Domain & WEBCastle Status
        // addSubTitle(`${this.start_wc}.1.5. Domain & WEBCastle Status`, 2)
        // addTable({
        //   headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
        //   columnStyles: {
        //     0: { valign : 'middle',  fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     1: { valign : 'middle',  fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     2: { valign : 'middle',  fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //     3: { valign : 'middle',  fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
        //   },
        //   head: [
        //     [ { content: 'Domain', colSpan: 2 }, { content: 'Installed WEBCastle', colSpan: 2 } ],
        //     [ 'Name', 'Status', 'Name', 'Status' ]
        //   ],
        //   body: [
        //     [ 'Domain 1', 'On', 'WEBCastle', 'On' ]
        //   ]
        // })

        // 2. Web Hacking Attack Detection & Blocking (WEBCastle) > 2.2. Monitoring Status
        doc.addPage(0, true) // 강제 페이지 나눔
        await doc.addSubTitle(this.get_index_title(), 1)
        await doc.addSubTitle(this.get_index_title(), 2)

        // add total
        await doc.addSubTitle(this.get_index_title(), 3)
        await doc.addChart(this.WebCastle_Daily_Detecting, 3, 160, 80)

        await doc.addSubTitle(this.get_index_title(), 3)
        await doc.addChart(this.WebCastle_Daily_Blocking, 3, 160, 80)


        doc.addPage(0, true) // 강제 페이지 나눔
        await doc.addSubTitle(this.get_index_title(), 2)
        doc.addSpacing(1)

        // Daily Detecting & Blocking server
        if(this.show_wc_agent() || (this.is_wc && !this.is_wsf && !this.is_wmds && !this.is_wf)) {

          for (let k = 0; k < this.WebCastle_Daily_log_by_server.length; k++) {
            this.WebCastle_Daily_log_by_server[k].deleted_at = this.WebCastle_Daily_log_by_server[k].deleted_at == undefined ? '' : this.WebCastle_Daily_log_by_server[k].deleted_at
            let x = this.get_index_title()

            await doc.addSubTitle(x, 3)
            await doc.addChart(this.WebCastle_Daily_log_by_server[k], 3, 160, 80) // 여기가 문제인거 같은데?

            if(this.WebCastle_Daily_log_by_server.length - 1 == k) { continue }
            if((k - 1) % 2 == 0) {
              doc.addPage(0, true) // 강제 페이지 나눔
            } else {
              doc.addSpacing(3)
            }
          }
          if(!this.WebCastle_Daily_log_by_server.length) {
            // 빈 차트 넣어 줘야 함
            await doc.addChart(this.blank_chart_data, 3, 160, 80)
          }
        } else {
          console.log("agent now showing")
        }

        // Daily Detecting & Blocking Domain
        if(this.show_wc_domain() || (this.is_wc && !this.is_wsf && !this.is_wmds && !this.is_wf)) {

          if(this.show_wc_agent() && this.WebCastle_Daily_log_by_server.length) { doc.addPage(0, true) } // 강제 페이지 나눔

          for (let k = 0; k < this.WebCastle_Daily_log_by_domain.length; k++) {
            let row = this.WebCastle_Daily_log_by_domain[k]

            if(row.name == undefined || row.name == '') { row.name = '' }

            if(row.name.length > 20) {
              await doc.addSubTitle(this.get_index_title(), 4)
            } else {
              await doc.addSubTitle(this.get_index_title(), 3)
            }

            await doc.addChart(row, 3, 160, 80)

            if(this.WebCastle_Daily_log_by_server.length - 1 == k) { continue }
            if((k - 1) % 2 == 0) {
              // 미지막이면 강제 추가 안함
              doc.addPage(0, true) // 강제 페이지 나눔
            } else {
              doc.addSpacing(3)
            }
          }
        } else {
          console.log("domain now showing")
        }

        // doc.addPage(0, true) // 강제 페이지 나눔
        await doc.addSubTitle(this.get_index_title(), 2)

        // 강제 페이지 나눔
        // doc.addPage(0, true) // 강제 페이지 나눔

        doc.dataBody = []
        doc.dataBody.push([
          {},
          { content : this.i18n_data['detect'][this.i18n], valign : 'middle', styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
          { content : this.i18n_data['block'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
          { content : this.i18n_data['level'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
          { content : this.i18n_data['total'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
        ])
        let chart_collection = {}
        let numberOfSeverity_collection = {}

        if (this.WebCastle_total_info_by_server_2_2_3_1.length > 0) {

          for (let l = 0; l < this.WebCastle_total_info_by_server_2_2_3_1.length; l++) {
            const server = this.WebCastle_total_info_by_server_2_2_3_1[l];

            // let row = this.WebCastle_Daily_log_by_server[k]
            let is_show_server = (this.is_wc && !this.is_wsf && !this.is_wmds && !this.is_wf) && (!this.agent.length || (!this.domain.length && _.filter(this.agent, a => a.nickname == server.name).length > 0))
            if(!is_show_server) { continue; }

            let numberOfSeverity = server.severity.length
            // if(numberOfSeverity < 1) { numberOfSeverity = 1 }
            numberOfSeverity = numberOfSeverity >= 3 ? numberOfSeverity : 3
            // console.log('numberOfSeverity', numberOfSeverity, server.severity.length)

            let row = []
            let key = `${server.name}.${l}`
            let start = new Date().getTime()
            chart_collection[key] = await doc.addDoughnutChart(this.get_doughnut_data(server.severity), 3, 20, 20)
            numberOfSeverity_collection[key] = numberOfSeverity

            console.log(start - new Date().getTime(), 'ms!!')

            // console.log(rs)
            if(server.severity.length) {
              let severity = _.sortBy(server.severity, 'total', false)

              row.push({ content: server.name, rowSpan : numberOfSeverity, styles: { valign : 'middle' }})
              row.push({ content: server.detect, rowSpan : numberOfSeverity, styles: { valign : 'middle' }})
              row.push({ content: server.block, rowSpan : numberOfSeverity, styles: { valign : 'middle' } })
              // console.log('collection key', key, severity)
              for (let i = 0; i < severity.length; i++) {
                // console.log('server.name', server.name, 'numberOfSeverity', severity[i].Key, this.codes.WAF_SEVERITY_TO_DESC_EASY(severity[i].Key))
                row.push({ content : this.codes.WAF_SEVERITY_TO_DESC_EASY(severity[i].Key, this.i18n), styles : { textColor : this.codes.WAF_SEVERITY_TO_COLOR_EASY(severity[i].Key) } })
                row.push({ content : severity[i].Value })
                row.push({
                  content : key,
                  rowSpan : numberOfSeverity,
                  styles : { textColor : '#fff', fontSize : 1 } // 글씨 감추기 위한 트릭
                })
                doc.dataBody.push(row)
                row = []
              }

              if(severity.length < 4) {
                _.forEach(new Array(3 - severity.length), () => {
                  row.push({ content : '-' })
                  row.push({ content : '-' })
                  row.push({ content : '-' })
                  doc.dataBody.push(row)
                })
              }
            } else if(numberOfSeverity == 3) {
              // 보정
              row.push({ content: server.name })
              row.push({ content: server.detect })
              row.push({ content: server.block })
              row.push({ content : 'N/A' })
              row.push({ content : 'N/A' })
              row.push({ content : 'N/A' })
              doc.dataBody.push(row)

              row = []
            }
          }
        } else {
          doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
        }

        //  Total number and Risk info per server
        // 서버와 도메인이 둘다 있을 경우는 서버 제외
        if(this.show_wc_agent() || this.is_wc) {
          await doc.addSubTitle(this.get_index_title(), 3)
          // Total number and Risk info per server
          await doc.addTable({
            headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
            columnStyles: {
              0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              1: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              2: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              3: { fontStyle: 'bold', halign: 'center', cellWidth: 25, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              4: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              5: { fontStyle: 'bold', halign: 'center', cellWidth: 22, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            },
            head: [
              [
                { content : this.i18n_data['server_name'][this.i18n], rowSpan : 2, styles: { halign: 'center' }},
                { content : this.i18n_data['event'][this.i18n], colSpan : 2 },
                { content : this.i18n_data['risk'][this.i18n], colSpan : 2 },
                { content : this.i18n_data['diagram'][this.i18n], rowSpan : 2, styles : { halign: 'center' } },
              ]
            ],
            body: doc.dataBody,
            didDrawCell: async (data) => {
              try {
                console.log('data', data, data.row.index, data.column.index, data.cell.raw)

                if (data.section === 'body' && data.row.index > 0 && data.column.index === 5) {
                  if(data.cell.raw) {
                    let img = chart_collection[data.cell.raw.content]
                    let row_span = numberOfSeverity_collection[data.cell.raw.content]
                    if(img) {
                      // data.cell.raw.content = ''
                      // TODO : 리스크 수만큼 늘어날 수 있도록 해야 함
                      let start = new Date().getTime()
                      console.log('start', start)

                      await doc.doc.addImage(img, 'PNG', data.cell.x + 3, data.cell.y + 2 + Math.round((row_span / 3 * 1.2), 0), 15, 15)
                      console.log('data.cell 1', new Date().getTime() - start, 'ms', data.cell)
                    } else { console.log('no have matched chart') }
                  } else { console.log("no have it") }
                }
              } catch (e) {
                console.log(e)
              }
            },
          })
        } else {
          console.log('not show agent for doughnut chart')
        }

        // 도메인별 위험도
        doc.dataBody = []
        doc.addPage(0, true) // 강제 페이지 나눔

        if(this.show_wc_domain()) {

          await doc.addSubTitle(this.get_index_title(), 3)

          // 강제 페이지 나눔
          // doc.addPage(0, true) // 강제 페이지 나눔

          doc.dataBody.push([
            {},
            { content : this.i18n_data['detect'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
            { content : this.i18n_data['block'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
            { content : this.i18n_data['level'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
            { content : this.i18n_data['total'][this.i18n], styles : { fillColor: '#3D63BA', textColor: '#fff', valign : 'middle',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' } },
          ])
          chart_collection = {}
          numberOfSeverity_collection = {}


          // console.log('this.WebCastle_total_info_by_server_2_2_3_2', this.WebCastle_total_info_by_server_2_2_3_2)

          if (this.WebCastle_total_info_by_server_2_2_3_2.length > 0) {
            for (let l = 0; l < this.WebCastle_total_info_by_server_2_2_3_2.length; l++) {
              const server = this.WebCastle_total_info_by_server_2_2_3_2[l];
              let numberOfSeverity = server.severity.length
              // if(numberOfSeverity < 1) { numberOfSeverity = 1 }
              numberOfSeverity = numberOfSeverity >= 3 ? numberOfSeverity : 3
              // console.log('numberOfSeverity', numberOfSeverity, server.severity.length)

              let row = []
              let key = `${server.host}.${l}`
              chart_collection[key] = await doc.addDoughnutChart(this.get_doughnut_data(server.severity), 3, 20, 20)
              numberOfSeverity_collection[key] = numberOfSeverity


              // console.log(rs)
              if(server.severity.length) {
                let severity = _.sortBy(server.severity, 'total', false)

                row.push({ content: server.host, rowSpan : numberOfSeverity, styles: { valign : 'middle' }})
                row.push({ content: server.detect, rowSpan : numberOfSeverity, styles: { valign : 'middle' }})
                row.push({ content: server.block, rowSpan : numberOfSeverity, styles: { valign : 'middle' } })
                // console.log('collection key', key, severity)
                for (let i = 0; i < severity.length; i++) {
                  // console.log('server.host', server.host, 'numberOfSeverity', severity[i].Key, this.codes.WAF_SEVERITY_TO_DESC_EASY(severity[i].Key))
                  row.push({ content : this.codes.WAF_SEVERITY_TO_DESC_EASY(severity[i].Key, this.i18n), styles : { textColor : this.codes.WAF_SEVERITY_TO_COLOR_EASY(severity[i].Key) } })
                  row.push({ content : severity[i].Value })
                  row.push({
                    content : key,
                    rowSpan : numberOfSeverity,
                    styles : { textColor : '#fff', fontSize : 1 } // 글씨 감추기 위한 트릭
                  })
                  doc.dataBody.push(row)
                  row = []
                }

                if(severity.length < 4) {
                  _.forEach(new Array(3 - severity.length), () => {
                    row.push({ content : '-' })
                    row.push({ content : '-' })
                    row.push({ content : '-' })
                    doc.dataBody.push(row)
                  })
                }
              } else if(numberOfSeverity == 3) {
                // 보정
                row.push({ content: server.host })
                row.push({ content: server.detect })
                row.push({ content: server.block })
                row.push({ content : 'N/A' })
                row.push({ content : 'N/A' })
                row.push({ content : 'N/A' })
                doc.dataBody.push(row)

                row = []
              }
            }
          } else {
            doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
          }

          //  Total number and Risk info per domain
          await doc.addTable({
            headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
            columnStyles: {
              0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              1: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              2: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              3: { fontStyle: 'bold', halign: 'center', cellWidth: 25, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              4: { fontStyle: 'bold', halign: 'center', cellWidth: 15, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              5: { fontStyle: 'bold', halign: 'center', cellWidth: 22, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            },
            head: [
              [
                { content : this.i18n_data['domain'][this.i18n], rowSpan : 2, styles: {} },
                { content : this.i18n_data['event'][this.i18n], colSpan : 2, styles : { valign : 'middle' } },
                { content : this.i18n_data['risk'][this.i18n], colSpan : 2, styles : { valign : 'middle' } },
                { content : this.i18n_data['diagram'][this.i18n], rowSpan : 2, styles : { halign: 'center' } },
              ]
            ],
            body: doc.dataBody,
            didDrawCell: async (data) => {
              // console.log('data', data, data.row.index, data.column.index, data.cell.raw)

              if (data.section === 'body' && data.row.index > 0 && data.column.index === 5) {
                if(data.cell.raw) {
                  let img = chart_collection[data.cell.raw.content]
                  let row_span = numberOfSeverity_collection[data.cell.raw.content]
                  if(img) {
                    console.log('data.cell 2', data.cell)
                    // data.cell.raw.content = ''
                    // TODO : 리스크 수만큼 늘어날 수 있도록 해야 함
                    await doc.doc.addImage(img, 'PNG', data.cell.x + 3, data.cell.y + 2 + Math.round((row_span / 3 * 1.2), 0), 15, 15)
                  } else { console.log('no have matched chart') }
                } else { console.log("no have it") }
              }
            },
          })
        } else {
          console.log('not show domain for doughnut chart')
        }

        // TOP 10 Events per individual
        // doc.addSpacing(10)
        doc.addPage(0, true) // 강제 페이지 나눔
        await doc.addSubTitle(this.get_index_title(), 2)
        doc.dataBody = []
        let table_rows_total = 0

        // TOP 10 events peer total individual
        if(this.show_wc_agent()) {

          if (this.webcastle.top_n_attack_from.length > 0) {

            await doc.addSubTitle(this.get_index_title(), 3)

            for (let k = 0; k < this.webcastle.top_n_attack_from.length; k++) {
              const WC_2_2_3_1 = this.webcastle.top_n_attack_from[k];
              // console.log(this.webcastle_msg(WC_2_2_3_1.message), "WTF")
              doc.dataBody.push([
                k + 1,
                WC_2_2_3_1.remote_addr,
                WC_2_2_3_1.target,
                this.webcastle_msg(WC_2_2_3_1.title_i18n ? WC_2_2_3_1.title_i18n : WC_2_2_3_1.message),
                WC_2_2_3_1.detect,
                WC_2_2_3_1.block,
                {
                  content : codes.WAF_SEVERITY_TO_DESC_EASY(WC_2_2_3_1.severity, this.i18n),
                  styles : { textColor : codes.WAF_SEVERITY_TO_COLOR_EASY(WC_2_2_3_1.severity) }
                }
              ])
            }
          } else {
            doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
          }

          // 서버 상위 10개 이벤트 (total)
          await doc.addTable({
            headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
            columnStyles: {
              // 0: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              // 1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              // 2: { fontStyle: 'bold', halign: 'center', cellWidth: '150px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              // 3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              // 4: { fontStyle: 'bold', halign: 'center', cellWidth: '100px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              // 5: { fontStyle: 'bold', halign: 'center', cellWidth: '100px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              // 6: { fontStyle: 'bold', halign: 'center', cellWidth: '200px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }

              0: { fontStyle: 'bold', halign: 'center', cellWidth: 8, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              1: { fontStyle: 'bold', halign: 'center', cellWidth: 33, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              2: { fontStyle: 'bold', halign: 'center', cellWidth: 40, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              4: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              5: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
              6: { fontStyle: 'bold', halign: 'center', minCellWidth : 16, cellWidth: 22, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            },
            head: [
              [ { content : this.i18n_data['no'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                { content : this.i18n_data['attacker_ip'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                { content : this.i18n_data['server'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                { content : this.i18n_data['event'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                { content : this.i18n_data['detail_event'][this.i18n], colSpan : 3 }
              ],
              [
                { content : this.i18n_data['detect'][this.i18n], styles : { valign : 'middle' } },
                { content : this.i18n_data['block'][this.i18n], styles : { valign : 'middle' } },
                { content : this.i18n_data['risk'][this.i18n], styles : { valign : 'middle' } }
              ]
              // [ 'No.', 'Attacker IP', 'Victim', 'Events',  'Detected', 'Blocked', 'Risk' ]
            ],
            body: doc.dataBody
          })
          table_rows_total += doc.dataBody.length
          if(table_rows_total > 25) { table_rows_total = 0; doc.addPage(0, true); }

          doc.dataBody = []

          // 상위 10개 이벤트 (서버별)
          // if(!(this.is_wc && !this.is_wsf && !this.is_wmds && !this.is_wf) && !this.domain) {
          this.webcastle.top_n_attack_agent && this.webcastle.top_n_attack_agent.length ? doc.addPage(0, true) : '' // 강제 페이지 나눔

          let table_count = 0
          doc.pageing = 0
            for (let k = 0; k < this.webcastle.top_n_attack_agent.length; k++) {
              if(table_count > 25) {
                doc.addPage(0, true) // 강제 페이지 나눔
                table_count = 0
              }
              const agent = this.webcastle.top_n_attack_agent[k];

              await doc.addSubTitle(this.get_index_title(), 3)

              // 에이전트별 구분
              doc.dataBody = _.map(agent.data, (WC_2_2_3_1, index) => {

                return [
                  index + 1,
                  WC_2_2_3_1.remote_addr,
                  // WC_2_2_3_1.target,
                  this.webcastle_msg(WC_2_2_3_1.title_i18n ? WC_2_2_3_1.title_i18n : WC_2_2_3_1.message),
                  WC_2_2_3_1.detect,
                  WC_2_2_3_1.block,
                  {
                    content : codes.WAF_SEVERITY_TO_DESC_EASY(WC_2_2_3_1.severity, this.i18n),
                    styles : { textColor : codes.WAF_SEVERITY_TO_COLOR_EASY(WC_2_2_3_1.severity) }
                  }
                ]
              })

              table_count += doc.dataBody.length

              if(agent.data.length < 1) { doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ]) }

              await doc.addTable({
                headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
                columnStyles: {
                  0: { fontStyle: 'bold', halign: 'center', cellWidth: 8, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                  1: { fontStyle: 'bold', halign: 'center', cellWidth: 33, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                  2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                  3: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                  4: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                  5: { fontStyle: 'bold', halign: 'center', minCellWidth : 16, cellWidth: 22, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                },
                head: [
                  [
                    { content : this.i18n_data['no'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                    { content : this.i18n_data['attacker_ip'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                    { content : this.i18n_data['message'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                    { content : this.i18n_data['detail_event'][this.i18n], colSpan : 3 }
                  ],
                  [
                    this.i18n_data['detect'][this.i18n],
                    this.i18n_data['block'][this.i18n],
                    this.i18n_data['risk'][this.i18n]
                  ]
                ],
                body: doc.dataBody
              })

              doc.pageing += doc.dataBody.length
              if(doc.pageing >= 15) {
                doc.addPage(0, true) // 강제 페이지 나눔
                doc.pageing = 0
              }

              doc.dataBody = []
            }

            this.webcastle.agent_list && this.webcastle.agent_list.length ? doc.addPage(0, true) : '' // 강제 페이지 나눔
          } else {
            console.log('no show top 10 of agent total, top 10 of agent')
          }
        // }

        doc.dataBody = []

        // 2.2.4
        doc.addSpacing(1)

        if(this.show_wc_domain()) {

          await doc.addSubTitle(this.get_index_title(), 3)

          // 도메인별 토탈 나오기
          // addSubTitle(`${this.start_wc}.2.4.1. TOP 10 Events Domain(Host) Total`, 3)
          // TOP 10 Events Domain(Host) Total
          if (this.webcastle.top_n_attack_from.length > 0) {
            this.webcastle.top_n_attack_from.forEach((WC_2_4_1, index) => {
              doc.dataBody.push([
                index + 1,
                WC_2_4_1.remote_addr,
                WC_2_4_1.target,
                this.webcastle_msg(WC_2_4_1.title_i18n ? WC_2_4_1.title_i18n : WC_2_4_1.message),
                WC_2_4_1.detect,
                WC_2_4_1.block,
                {
                  content : codes.WAF_SEVERITY_TO_DESC_EASY(WC_2_4_1.severity, this.i18n),
                  styles : { textColor : codes.WAF_SEVERITY_TO_COLOR_EASY(WC_2_4_1.severity) }
                }
              ])
            })
          } else {
            doc.dataBody.push([ 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A' ])
          }

          // 상위 10개 도메인(Host) Total
          await doc.addTable({
          headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
          columnStyles: {
            // 0: { fontStyle: 'bold', halign: 'center', cellWidth: '10px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            // 1: { fontStyle: 'bold', halign: 'center', cellWidth: '150px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            // 2: { fontStyle: 'bold', halign: 'center', cellWidth: '250px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            // 3: { fontStyle: 'bold', halign: 'center', cellWidth: '150px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            // 4: { fontStyle: 'bold', halign: 'center', cellWidth: '150px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            // 5: { fontStyle: 'bold', halign: 'center', cellWidth: '150px', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            // 6: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }

            0: { fontStyle: 'bold', halign: 'center', cellWidth: 8, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 33, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            2: { fontStyle: 'bold', halign: 'center', cellWidth: 40, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            3: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            4: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            5: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
            6: { fontStyle: 'bold', halign: 'center', minCellWidth : 16, cellWidth: 22, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
          },
          head: [
            [
              { content : this.i18n_data['no'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
              { content : this.i18n_data['attacker_ip'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
              { content : this.i18n_data['target'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
              { content : this.i18n_data['message'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
              { content : this.i18n_data['detail_event'][this.i18n], colSpan : 3 }
            ],
            [
              { content : this.i18n_data['detect'][this.i18n], styles : { valign : 'middle' } },
              { content : this.i18n_data['block'][this.i18n], styles : { valign : 'middle' } },
              { content : this.i18n_data['risk'][this.i18n], styles : { valign : 'middle' } }
            ]
          ],
          body: doc.dataBody
        })

        // this.webcastle && this.webcastle.top_n_attack_domain.length ? doc.addPage(0, true) : '' // 강제 페이지 나눔
        doc.dataBody = []
        // 페이징 필요
        doc.pageing = 0
          for (let k = 0; k < this.webcastle.top_n_attack_domain.length; k++) {
            const domain = this.webcastle.top_n_attack_domain[k];

            console.log('domain start', domain.name)

            // if(agent.evnet_by_domain.length > 0) {

            await doc.addSubTitle(this.get_index_title(), 3)
            // 도메인별 구분 구분
            doc.dataBody = _.map(domain.data, (WC_2_2_3_1, index) => {
              return [
                (index + 1),
                WC_2_2_3_1.remote_addr,
                this.webcastle_msg(WC_2_2_3_1.title_i18n ? WC_2_2_3_1.title_i18n : WC_2_2_3_1.message),
                WC_2_2_3_1.detect,
                WC_2_2_3_1.block,
                {
                  content : codes.WAF_SEVERITY_TO_DESC_EASY(WC_2_2_3_1.severity, this.i18n),
                  styles : { textColor : codes.WAF_SEVERITY_TO_COLOR_EASY(WC_2_2_3_1.severity) }
                }
              ]
            })

            // 상위 10개 도메인(Host) Total
            await doc.addTable({
              headStyles: { fillColor: '#3D63BA', textColor: '#fff',  fontStyle: 'bold', halign: 'center', lineWidth: 0.3, lineColor: '#000' },
              columnStyles: {
                0: { fontStyle: 'bold', halign: 'center', cellWidth: 8, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                1: { fontStyle: 'bold', halign: 'center', cellWidth: 40, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                2: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                3: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                4: { fontStyle: 'bold', halign: 'center', minCellWidth : 14, cellWidth: 16, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                5: { fontStyle: 'bold', halign: 'center', minCellWidth : 16, cellWidth: 22, cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                // 6: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' },
                // 7: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
              },
              head: [
                [
                  { content : this.i18n_data['no'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                  { content : this.i18n_data['attacker_ip'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                  { content : this.i18n_data['message'][this.i18n], rowSpan : 2, styles : { valign : 'middle' } },
                  { content : this.i18n_data['detail_event'][this.i18n], colSpan : 3 }
                ],
                [
                  { content : this.i18n_data['detect'][this.i18n], styles : { valign : 'middle' }},
                  { content : this.i18n_data['block'][this.i18n], styles : { valign : 'middle' }},
                  { content : this.i18n_data['risk'][this.i18n], styles : { valign : 'middle' }}
                ]
              ],
              body: doc.dataBody.length ? doc.dataBody : ['N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A']
            })

            doc.pageing += doc.dataBody.length
            if(doc.pageing >= 15) {
              doc.addPage(0, true) // 강제 페이지 나눔
              doc.pageing = 0
            }

            doc.dataBody = []

          }
        }

        doc.addPage(0, true) // 강제 페이지 나눔
        await doc.addSubTitle(this.get_index_title(), 3)
        await doc.addSubTitle(this.get_index_title(), 4)

        // attack trend
        await doc.addChart(this.WebCastle_attack_trend_total_2_3, 3, 160, 80)
        doc.addSpacing(2)
      } catch (e) {
        console.log(e)
        console.log('[-] generate report webcastle part failed')
        this.$toastr.w('generate report webcastle part failed')
      }
      return doc
    },
    // 내보내기 부분 대부분 수정 됨, 작은 버그들이 있을 수 있음
    async makePDF() {
      let base = new jsPDF({ compress: true })

      base = SetMalgun(base)
      base = SetMalgunbd(base)
      // 일본어 제외, 사용 안하고 용량 차지함
      // base = SetNotoSansCJKjp(base) // japanese, also working hangle
      // base = SetNotoSansCJKjpbd(base)

      // set font
      // console.log(this.i18n, 'fonts', doc.getFontList(), doc)
      // doc.setFont('NotoSansCJKjp');
      // doc.setFontStyle("normal");
      base.setFont('Malgun');

      try {
        // start report!!!!
        this.$toastr.s(this.i18n_data['plz_wait'][this.i18n]);
        this.loading = true

        let doc = new f1pdf(base)

        // init page
        console.log(doc)
        doc.initPage()

        // 1st page logo!!
        let logo = this.custom.image ? this.custom.image : await doc.getDataUri(logoImageUrl)
        let footer = await doc.getDataUri(logoFooterUrl)

        doc.addSpacing(1)
        doc.setTextColor("#FF0000")
        doc.setFontSize(18);

        document.getElementById('doc_type') ? doc.addText(document.getElementById('doc_type').innerHTML, 20, 'center') : doc.addSpacing(5)

        doc.addSpacing(5)
        doc.setFontSize(24);
        doc.setTextColor("#3D63BA")

        let sub_title = document.getElementById('doc_report_full_title').innerHTML

        if(sub_title) {
          // f1security
          doc.addText(document.getElementById('doc_report_short_title').innerHTML, 19, 'center')
          doc.addSpacing(3)
          doc.setTextColor("#829DD4")
          doc.addText(sub_title, 19, 'center')
        } else {
          // custom
          doc.addText(document.getElementById('doc_report_short_title').innerHTML, 19, 'center')
          doc.addSpacing(3)
        }

        doc.setTextColor("#000000")


        if(!this.is_report_custom) {
          // monthly
          doc.addSpacing(2)
          doc.setFontSize(18);
          doc.addText(document.getElementById('doc_date_monthly').innerHTML, 19)
        }

        this.is_report_custom ? doc.addSpacing(11.5) : doc.addSpacing(7.5)
        doc.setFontSize(15);
        doc.addText(document.getElementById('doc_username').innerHTML, 19)

        doc.addSpacing(1)
        doc.addText(this.from + " ~ " + this.to, 19);
        doc.addSpacing(2)

        doc.setFontSize(12);
        doc.addSpacing(4)
        // doc.addSpacing(10)
        // doc.addText(document.getElementById('doc_caution_title').innerHTML, 19)
        doc.addSpacing(1)

        doc.setDrawColor("#cccccc")
        // doc.rect(9 * 5, doc.finalY - 20, 120, 55)

        doc.setFontSize(10);
        // let rs = document.getElementsByClassName('doc_caution_content')

        // _.map(rs, x => x.innerHTML.replace('&amp;', '') ? doc.addText(x.innerHTML.replace('&amp;', ''), 8, '') : '')

        doc.addSpacing(6)
        doc.addSpacing(17)
        doc.doc.addImage(footer, 'PNG', doc.baseX - 20, doc.finalY - 70, 220, 80);
        doc.addPage()
        doc.resetTextStyle();
        // end of 1st page

        // Contents (index)
        doc.setFontSize(18)
        doc.addText(this.i18n_data['contents'][this.i18n], 19)

        doc.setFontSize(10)
        let index_list = document.getElementsByClassName('index')
        this.index_title_list = []
        index_list.forEach(x => {
          let title = x.innerHTML.replace('&amp;', '&').replace(/&nbsp;/gm, '').replace(/(.{0,1}[<|<\/]small>)/g, '')
          doc.addText(title, (x.innerHTML.match(/(&nbsp)/ig) || []).length / 2, '')
          this.index_title_list.push(title.replace(')(', ') (')) // 보정
        })

        // start summary
        doc.setFontSize(9);
        doc.addPage(0, true)

        // 여기서부터 주석 처리됨
        // index : 1
        await doc.addTitle(this.get_index_title(), 0)

        // index : 1.1
        // 보고서 부분
        doc.addSubTitle(this.get_index_title(), 1)
        await doc.addTable({
          columnStyles: {
            0: { fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', halign: 'center', cellWidth: 70, lineWidth: 0.3, lineColor: '#000' },
            1: { fontStyle: 'bold', halign: 'center', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: [
            [ this.i18n_data['username'][this.i18n], auth.profile.username ],
            [ this.i18n_data['report_period'][this.i18n], this.from + ' ~ ' + this.to ]
          ]
        })

        // index : 1.2
        await doc.addSubTitle(this.get_index_title(), 1)

        doc.dataBody = []

        let joined_at = this.SUMMARY.joined_at ? moment(this.SUMMARY.joined_at).format('YYYY-MM-DD') : moment(this.wmds_summary.general_information.created_at).format("YYYY-MM-DD")
        let last_visit = this.SUMMARY.updated_at ? moment(this.SUMMARY.updated_at).format('YYYY-MM-DD') : moment(this.wmds_summary.general_information.last_visit).format("YYYY-MM-DD")
        // now subscription
        doc.dataBody.push([ { content: this.i18n_data['reg_date'][this.i18n], colSpan: 2 }, joined_at + ' / ' + last_visit ])
        doc.dataBody.push([ { content: this.i18n_data['service_type'][this.i18n], colSpan: 2 }, this.SUMMARY.service_name ? this.SUMMARY.service_name : '-' ])

        // prev subscription
        if(this.SUMMARY.prev_subscription && this.SUMMARY.prev_subscription.length) {
          this.SUMMARY.prev_subscription.forEach(l => doc.dataBody.push([ { content: this.i18n_data['service_type_prev'][this.i18n], colSpan: 2 }, l ]))
        }

        // description service status
        doc.dataBody.push([
          { content: this.i18n_data['protect_function'][this.i18n], rowSpan: 4, styles : { valign: 'middle' } },
          this.i18n_data['webcastle'][this.i18n],
          { content : (['Pro', 'Premium', 'Basic'].indexOf(this.SUMMARY.service_name) > -1 ? this.i18n_data['included'][this.i18n] : 'N/A'), styles : { valign: 'middle' } }
        ])
        doc.dataBody.push([
          this.i18n_data['wsfinder'][this.i18n],
          { content : (['Pro', 'Premium'].indexOf(this.SUMMARY.service_name) > -1 ? this.i18n_data['included'][this.i18n] : 'N/A'), styles : { valign: 'middle' } }
        ])
        doc.dataBody.push([
          this.i18n_data['wmds'][this.i18n],
          { content : (['Pro', 'Premium', 'Basic'].indexOf(this.SUMMARY.service_name) > -1 ? this.i18n_data['included'][this.i18n] : 'N/A'), styles : { valign: 'middle' } }
        ])
        doc.dataBody.push([
          this.i18n_data['wfdetect'][this.i18n],
          { content : (['Pro', 'Premium', 'Basic'].indexOf(this.SUMMARY.service_name) > -1 ? this.i18n_data['included'][this.i18n] : 'N/A'), styles : { valign: 'middle' } }
        ])

        // desc 1.2 !!!
        await doc.addTable({
          columnStyles: {
            0: { halign : 'center', fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', cellWidth: 35, lineWidth: 0.3, lineColor: '#000' },
            1: { halign: 'center', fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', cellWidth: 35, lineWidth: 0.3, lineColor: '#000' },
            2: { halign : 'center', fontStyle: 'bold', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000' }
          },
          body: doc.dataBody
        })

        doc.dataBody = []

        // index : 1.3
        await doc.addSubTitle(this.get_index_title(), 1)
        let using = (x) => { return x && x > 0 ? x : 'N/A' }
        await doc.addTable({
          columnStyles: {
            0: { halign: 'center', fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', cellWidth: 35, lineWidth: 0.3, lineColor: '#000', rowSpan : 2 },
            1: { halign: 'center', fillColor: '#3D63BA', textColor: '#fff', fontStyle: 'bold', cellWidth: 35, lineWidth: 0.3, lineColor: '#000', rowSpan : 2 },
            2: { halign: 'center', fontStyle: 'bold', cellWidth: 'auto', cellHeight: 'auto', lineWidth: 0.3, lineColor: '#000', rowSpan : 2 }
          },
          body: [
            [ { content: this.i18n_data['protect_function'][this.i18n], rowSpan: 8, styles: { valign: 'middle' }}, this.i18n_data['webcastle'][this.i18n], this.is_wc ? (using(this.webcastle.agent_list_alive && this.webcastle.agent_list_alive.length ? this.webcastle.agent_list_alive.length : 0)) : 'N/A' ],
            [ this.i18n_data['wsfinder'][this.i18n], this.is_wsf ? using(this.wsfinder.summary_1_4.length) : 'N/A' ],
            [ this.i18n_data['wmds'][this.i18n], { content : this.is_wmds ? using(this.wmds.site_list_alive.length) : 'N/A', styles : { valign : 'middle' } } ],
            [ this.i18n_data['wfdetect'][this.i18n], using(this.wmds_summary.domain_and_wf_detector_status.length) ]
          ]
        })

        // 1.4
        doc.addPage(0, true) // 강제 페이지 나눔
        await doc.addSubTitle(this.get_index_title(), 1)

        console.log('this.webcastle.summary_1_4', this.webcastle.summary_1_4)
        console.log('this.wsfinder.summary_1_4', this.wsfinder.summary_1_4)
        console.log('this.wmds.summary_1_4', this.wmds.summary_1_4)

        let numOfRows = 0; // ??
        let numbersOfSummary = {
          castle: ((a) => { numOfRows += a > 0 ? a : 1; return a })(this.webcastle.summary_1_4.length),
          wsfinder: ((a) => { numOfRows += a > 0 ? a : 1; return a })(this.wsfinder.summary_1_4.length),
          wmds: ((a) => { numOfRows += a > 0 ? a : 1; return a })(this.wmds.summary_1_4.length),
          title: 4
        }
        let rowSpan = 7
        for (let a in numbersOfSummary) { rowSpan += Number(numbersOfSummary[a]); }
        rowSpan = rowSpan - Number(numbersOfSummary.title)
        rowSpan += this.webcastle.summary_1_4.length

        doc.dataBody = []

        // index 1.4 webcastle
        let WebSecurityConfigurationStatusWEBCastle_1 = [
          { content: this.i18n_data['service'][this.i18n], styles: { halign : 'center', valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, rowSpan : 2 },
          { content: this.i18n_data['name'][this.i18n], styles: { halign : 'center', valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, rowSpan : 2 },
          { content: this.i18n_data['name'][this.i18n], styles: { halign : 'center', valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, colSpan : 7 },
        ]
        doc.dataBody.push(WebSecurityConfigurationStatusWEBCastle_1)

        let WebSecurityConfigurationStatusWEBCastle_2 = [
          { content: this.i18n_data['mode'][this.i18n], styles: { halign : 'center', valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, colSpan : 2 },
          { content: this.i18n_data['level'][this.i18n], styles: { halign : 'center', valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['domain'][this.i18n], styles: { halign : 'center', valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, colSpan : 4 },
        ]
        doc.dataBody.push(WebSecurityConfigurationStatusWEBCastle_2)

        let WEBCastle = this.i18n == 'EN' ? 'WEBCastle' : this.i18n_data['webcastle'][this.i18n]+'\n(WEBCastle)'
        if (numbersOfSummary['castle']) {

          this.webcastle.summary_1_4.forEach((WC_1_4, index) => {
            let body = []
            if(index == 0) { body.push({ content : WEBCastle, rowSpan : this.webcastle.summary_1_4.length, styles : { valign : 'middle'} }); }

            body.push(WC_1_4.name)
            body.push({ content: codes.WAF_MODE_I18N(WC_1_4.mode, this.i18n), styles: { halign : 'center', textColor: (WC_1_4.mode == 'Off' ? '#000' : (WC_1_4.mode == 'On' ? '#f22' : '#fb0'  )) }, colSpan : 2 })
            body.push({ content: WC_1_4.level, styles: { halign : 'center', textColor: '#000' } })
            body.push({ content: WC_1_4.domain, styles: { halign : 'center', textColor: '#000' }, colSpan : 4 })

            doc.dataBody.push(body)
            // console.log(body)
          })
        } else {
          // doc.dataBody.push([WEBCastle, { content : 'N/A', colSpan : 7 }, { content : 'N/A', colSpan : 2 }, 'N/A', { content : 'N/A', colSpan : 4 }])
          doc.dataBody.push([WEBCastle, { content : 'N/A', colSpan : 8 }])
        }

        // index 1.4 wsfinder
        let WebSecurityConfigurationStatusWSFinder_1 = [
          { content: this.i18n_data['service'][this.i18n], styles: { valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, rowSpan : 2, halign : 'center' },
          { content: this.i18n_data['name'][this.i18n], styles: { valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, rowSpan : 2, halign : 'center' },
          { content: this.i18n_data['realtime'][this.i18n]+'\r\n'+this.i18n_data['mode'][this.i18n], styles: { valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, rowSpan : 2, halign : 'center' },
          { content: this.i18n_data['backup'][this.i18n] + '\r\n'+this.i18n_data['mode'][this.i18n], styles: { valign : 'middle', fillColor: '#3D63BA', textColor: '#fff' }, rowSpan : 2, halign : 'center' },
          { content: this.i18n_data['policy'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' }, rowSpan : 1, colSpan : 5 }
        ]
        doc.dataBody.push(WebSecurityConfigurationStatusWSFinder_1)

        let WebSecurityConfigurationStatusWSFinder_2 = [
          { content: 'Regex', styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: 'Hash', styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: 'URL', styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['ssdeep'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['obfuscation'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } }
        ]
        doc.dataBody.push(WebSecurityConfigurationStatusWSFinder_2)

        let WSFinder = this.i18n == 'EN' ? 'WSFinder' : this.i18n_data['wsfinder'][this.i18n]+'\n(WSFinder)'
        if (numbersOfSummary['wsfinder'] > 0) {
          this.wsfinder.summary_1_4.forEach((WSF_1_5, index) => {
            let body = []
            if(index == 0) { body.push({ content : WSFinder, rowSpan : numbersOfSummary['wsfinder'], styles : { valign : 'middle'} }); }

            body.push(WSF_1_5.host)
            body.push(((s) => {
              let d = { content : s.realtime_mode ? this.i18n_data['on'][this.i18n] : this.i18n_data['off'][this.i18n], styles : { textColor: s.realtime_mode ? '#527' : '#000'} }
              if(s.realtime_mode) {
                d.styles =  { textColor: '#4dbe74',  fontStyle: 'bold', halign: 'center' }
              }
              return d
            })(WSF_1_5.setting))
            body.push(((s) => {
              let d = { content : s.backup_mode ? this.i18n_data['on'][this.i18n] : this.i18n_data['off'][this.i18n], styles : {} }
              if(s.backup_mode) {
                d.styles =  { textColor: '#4dbe74',  fontStyle: 'bold', halign: 'center' }
              }
              return d
            })(WSF_1_5.setting))
            body.push(((s) => this.wsfinder_rule(s).indexOf('regex') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'))
            body.push(((s) => this.wsfinder_rule(s).indexOf('hash') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'))
            body.push(((s) => this.wsfinder_rule(s).indexOf('url') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'))
            body.push(((s) => this.wsfinder_rule(s).indexOf('ssdeep') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'))
            body.push(((s) => this.wsfinder_rule(s).indexOf('ob') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'))

            // let row = [
            //   ,
            //   ((s) => {
            //       let d = { content : JSON.parse(s).realtime_mode ? this.i18n_data['on'][this.i18n] : this.i18n_data['off'][this.i18n], styles : { textColor: JSON.parse(s).realtime_mode ? '#527' : '#000'} }
            //       if(JSON.parse(s).realtime_mode) {
            //         d.styles =  { textColor: '#4dbe74',  fontStyle: 'bold', halign: 'center' }
            //       }
            //       return d
            //     })(WSF_1_5.setting),
            //   ((s) => {
            //     let d = { content : JSON.parse(s).backup_mode ? this.i18n_data['on'][this.i18n] : this.i18n_data['off'][this.i18n], styles : {} }
            //     if(JSON.parse(s).backup_mode) {
            //       d.styles =  { textColor: '#4dbe74',  fontStyle: 'bold', halign: 'center' }
            //     }
            //     return d
            //   })(WSF_1_5.setting),
            //   ((s) => this.wsfinder_rule(s).indexOf('regex') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'),
            //   ((s) => this.wsfinder_rule(s).indexOf('hash') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'),
            //   ((s) => this.wsfinder_rule(s).indexOf('url') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'),
            //   ((s) => this.wsfinder_rule(s).indexOf('ssdeep') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'),
            //   ((s) => this.wsfinder_rule(s).indexOf('ob') > -1 ? 'V' : '-')(WSF_1_5.setting ? WSF_1_5.setting : '{}'),
            // ]
            doc.dataBody.push(body)
          })
        } else {
          doc.dataBody.push([WSFinder, { content : 'N/A', colSpan : 8 }])
          // doc.dataBody.push([WSFinder, 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A'])
        }

        // index 1.4 wmds
        let WebSecurityConfigurationStatusWMDS = [
          { content: this.i18n_data['service'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['name'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } },
          { content: this.i18n_data['schedule'][this.i18n], styles: { cellWidth: 20, fillColor: '#3D63BA', textColor: '#fff' }, colSpan : 2 },
          { content: this.i18n_data['policy'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' }, colSpan : 4 },
          { content: this.i18n_data['max_page'][this.i18n], styles: { fillColor: '#3D63BA', textColor: '#fff' } }
        ]
        doc.dataBody.push(WebSecurityConfigurationStatusWMDS)

        let WMDS = this.i18n == 'EN' ? 'WMDS' : this.i18n_data['wmds'][this.i18n]+'\n(WMDS)'
        if (numbersOfSummary['wmds'] > 0 && this.is_wmds) {
          this.wmds.summary_1_4.forEach((WMDS_1_5, index) => {
            let body = []
            if(index == 0) { body.push({ content : WMDS, rowSpan : numbersOfSummary['wmds'], styles : { valign : 'middle'} }); }

            body.push(WMDS_1_5.name)
            body.push({ content: _.join(this.wmds_schedule(JSON.parse(WMDS_1_5.schedule)), '\r\n'), colSpan: 2 })
            body.push({ content: WMDS_1_5.policy_name, colSpan: 4 })
            body.push({ content: number(WMDS_1_5.max_page) })

            // let row = [
            //   WMDS,
            //   WMDS_1_5.name,
            //   { content: _.join(this.wmds_schedule(JSON.parse(WMDS_1_5.schedule)), '\r\n'), colSpan: 2 },
            //   { content: WMDS_1_5.description, colSpan: 5 },
            // ]
            doc.dataBody.push(body)
          })
        } else {
          doc.dataBody.push([WMDS, { content : 'N/A', colSpan : 8 }])
          // doc.dataBody.push([ WMDS, 'N/A', { content: 'N/A', colSpan: 2 }, { content: 'N/A', colSpan : 5 } ])
        }

        // index: 1.4 (Draw table)
        // 표가 페이지 이상으로 넘어갈 경우, 표 페이징 필요
        let total = doc.dataBody.length
        let rows = 25
        let prev_headeer = []

        // paging
        for (let l = 0; l < Math.round(total / rows) + 1; l++) {

          let offset = (l * rows)
          let body = []
          // let is_done = false
          let page = doc.dataBody.slice(offset, offset + rows)
          let common = { content: this.i18n_data['configure'][this.i18n], styles: { valign : 'middle', fillColor: '#3D63BA', textColor: '#fff', fontSize : 9 }, rowSpan : page.length, halign : 'center' }
          let latest_header = ''

          // 하나의 페이지에 보여질 테이블 정보 수집
          for (let i = 0; i < page.length; i++) {
            let x = page[i];
            body.push(x)

            if(!body || body.length < 1) { continue }

            let now_head = x[0].content ? x[0].content : x[0]
            switch (now_head) {
              case 'WEBCastle':  latest_header = [].concat([WebSecurityConfigurationStatusWEBCastle_1]).concat([WebSecurityConfigurationStatusWEBCastle_2]); break;
              case 'WSFinder':  latest_header = [].concat([WebSecurityConfigurationStatusWSFinder_1]).concat([WebSecurityConfigurationStatusWSFinder_2]); break;
              case 'WMDS':  latest_header = [WebSecurityConfigurationStatusWMDS]; break;
            }
          }

          // 해당 페이지에 해더가 없을 경우, 맨 상단에 헤더 추가 필요
          if(body[0] && body[0][0].content != this.i18n_data['service'][this.i18n] && prev_headeer && prev_headeer.length) {
            // console.log('no have head for table', 'page', l, 'add head', prev_headeer, common)
            if(Array.isArray(prev_headeer)) {
              let custom_head = [common].concat(prev_headeer[0])
              body = [custom_head].concat(prev_headeer.slice(1, prev_headeer.length)).concat(body)
            } else {
              body = [[common, prev_headeer]].concat(body)
            }
          } else {
            // console.log('add default', 'page', l, 'head', prev_headeer, common)
            body = [[common].concat(body[0])].concat(body.slice(1, body.length))

          }
          body[0][0].rowSpan = body.length // 조정 필요

          if(body.length > 1 ) {
            l > 0 ? doc.addPage(0, true) : ''

            await doc.addTable({
              columnStyles: {
                0: { cellWidth : 20, valign : 'middle',  fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                1: { cellWidth : 30, fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                2: { cellWidth : 40, valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                3: { valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                4: { valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                5: { valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                6: { valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                7: { valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                8: { valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
                9: { valign : 'middle', fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 },
              },
              body: body
            })
            prev_headeer = latest_header
          }
        }

        // 초기화
        doc.dataBody = []

        if(this.is_wc) { doc = await this.make_pdf_webcastle(doc, numbersOfSummary) }
        if(this.is_wsf) { doc = await this.make_pdf_wsfinder(doc) }
        if(this.is_wmds) { doc = await this.make_pdf_wmds(doc) }
        if(this.is_wf) { doc = await this.make_pdf_wfdetect(doc) }

        // 이슈 없음
        // 마지막 페이지
        doc.addPage(0, true) // 강제 페이지 나눔
        logo ? doc.addImage(logo, 0, 53, 13) : doc.addSpacing(5)

        doc.setFontSize(24);
        // doc.setFontStyle("bold");
        doc.setTextColor("#3D63BA")

        doc.addSpacing(5)
        doc.addLastPage(this.is_f1security_slogan() ? 'F1-UWSS' : this.custom.slogan, 19, 5)

        doc.setFontSize(20);
        doc.setTextColor("#829DD4")
        doc.addLastPage('Service R&D Center', 19, 3)

        doc.line(doc.baseX + 40, doc.finalY - 10, doc.baseX + 150, doc.finalY - 10);

        doc.setTextColor("#000000")

        if(this.is_f1security_slogan()) {
          doc.addLastPage('Technical Support', 19, 5)
          // doc.line(baseX + 40, finalY - 10, baseX + 150, finalY - 10);

          if(this.auth.profile.language == 'KO') {
            doc.addLastPage('Korea E-mail: help@uwss.kr', 19, 5)
            this.auth.profile.service == 'Premium' ? doc.addLastPage('Korea Tel: 02-6223-3544', 19, 3) : ''
          } else {
            doc.addLastPage('Global E-mail: help@uwss.online', 19, 2)
            this.auth.profile.service == 'Premium' ? doc.addLastPage('Global Tel: +82-2-6223-3545', 19, 2) : ''
          }

          doc.addSpacing(5)

          doc.setFontSize(20);
          doc.setTextColor("#829DD4")
          doc.addText('End Of Document', 19)

          doc.addSpacing(5)
        } else {
          doc.addSpacing(18)
          doc.addText('End Of Document', 19)
          doc.addSpacing(4)
        }

        doc.doc.addImage(footer, 'PNG', doc.baseX - 20, doc.finalY, 220, 80);

        // save as file
        this.loading = false
        this.$toastr.s(this.i18n_data['export_done'][this.i18n]);
        this.index_title = -1

        return doc.save(`${this.custom.slogan || 'F1-UWSS'} Report (${this.from}-${this.to}).pdf`)

      } catch (e) {
        console.log(e)
        this.loading = false
        this.$toastr.e(this.i18n_data['generated_report_failed'][this.i18n])
      }
    },
    request_pdf() {
      let x = document.getElementById('pdf')

      api.util.pdf({ body : { html : x.innerHTML, option : '' } }).then(rs => {
        console.log('WTF', rs)

      }).catch(error => {
        console.error(error)
      })
    }
  },
  created: function() {
    this.from = moment(new Date()).format('YYYY-MM-DD');
    this.to = moment(new Date()).format('YYYY-MM-DD');
    this.opt.year = moment(this.from).format('YYYY')

    console.log(`[${this.custom.slogan}] Report.vue`, 'created');
  },
  destroyed: function() { console.log(`[${this.custom.slogan}] Report.vue`, 'destroyed'); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}] Report.vue`, 'mounted');
    console.log("report is", localStorage['UWSS_LANG'])

    this.is_wsf = this.auth.license.WSFinder.use
    this.is_wc = this.auth.license.WEBCastle.use
    this.is_wmds = this.auth.license.WMDS.use
    this.is_wf = this.auth.license.WFDetect.use

    // 현재는 영어만 사용
    for(let i = 0; i < 60; i++) {
      m_opt['EN'].push({ value: i.toString(), text: i +  ` ${this.i18n_data['min']['EN']}` });
      m_opt['KO'].push({ value: i.toString(), text: i +  ` ${this.i18n_data['min']['KO']}` });
    }
    for(let i = 0; i < 24; i++) {
      h_opt['EN'].push({ value: i.toString(), text: i + ` ${this.i18n_data['hour']['EN']}` });
      h_opt['KO'].push({ value: i.toString(), text: i + ` ${this.i18n_data['hour']['KO']}` });
    }

    // 도메인별
    this.getAgentList()
    this.getDomainList()

    if(location.hostname == 'localhost') {
      console.log(new f1pdf())
      // this.report('2020-11-01', '2020-11-25');
      this.is_wc = false
      this.is_wsf = true
      this.is_wmds = false
      this.is_wf = true
      // this.opt.month = "2022-04-01"

      // setTimeout(() => {
      //   this.is_report_custom = true
      //   this.report('2022-08-01', '2022-08-31')
      //   // setTimeout(() => {
      //   //   this.makePDF()

      //   // }, 2000)
      // }, 1000)
    }
  },
}
